// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-red-900: oklch(39.6% 0.141 25.723);
    --color-orange-50: oklch(98% 0.016 73.684);
    --color-orange-100: oklch(95.4% 0.038 75.164);
    --color-orange-200: oklch(90.1% 0.076 70.697);
    --color-orange-300: oklch(83.7% 0.128 66.29);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-orange-600: oklch(64.6% 0.222 41.116);
    --color-orange-700: oklch(55.3% 0.195 38.402);
    --color-orange-800: oklch(47% 0.157 37.304);
    --color-orange-900: oklch(40.8% 0.123 38.172);
    --color-orange-950: oklch(26.6% 0.079 36.259);
    --color-amber-50: oklch(98.7% 0.022 95.277);
    --color-amber-100: oklch(96.2% 0.059 95.617);
    --color-amber-200: oklch(92.4% 0.12 95.746);
    --color-amber-300: oklch(87.9% 0.169 91.605);
    --color-amber-400: oklch(82.8% 0.189 84.429);
    --color-amber-500: oklch(76.9% 0.188 70.08);
    --color-amber-600: oklch(66.6% 0.179 58.318);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-800: oklch(47.3% 0.137 46.201);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-amber-950: oklch(27.9% 0.077 45.635);
    --color-yellow-50: oklch(98.7% 0.026 102.212);
    --color-yellow-300: oklch(90.5% 0.182 98.111);
    --color-yellow-500: oklch(79.5% 0.184 86.047);
    --color-yellow-600: oklch(68.1% 0.162 75.834);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-300: oklch(87.1% 0.15 154.449);
    --color-green-400: oklch(79.2% 0.209 151.711);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-green-900: oklch(39.3% 0.095 152.535);
    --color-green-950: oklch(26.6% 0.065 152.934);
    --color-emerald-50: oklch(97.9% 0.021 166.113);
    --color-emerald-400: oklch(76.5% 0.177 163.223);
    --color-emerald-500: oklch(69.6% 0.17 162.48);
    --color-emerald-600: oklch(59.6% 0.145 163.225);
    --color-emerald-900: oklch(37.8% 0.077 168.94);
    --color-cyan-50: oklch(98.4% 0.019 200.873);
    --color-cyan-200: oklch(91.7% 0.08 205.041);
    --color-cyan-300: oklch(86.5% 0.127 207.078);
    --color-cyan-400: oklch(78.9% 0.154 211.53);
    --color-cyan-500: oklch(71.5% 0.143 215.221);
    --color-cyan-700: oklch(52% 0.105 223.128);
    --color-cyan-800: oklch(45% 0.085 224.283);
    --color-cyan-900: oklch(39.8% 0.07 227.392);
    --color-cyan-950: oklch(30.2% 0.056 229.695);
    --color-sky-500: oklch(68.5% 0.169 237.323);
    --color-sky-700: oklch(50% 0.134 242.749);
    --color-sky-800: oklch(44.3% 0.11 240.79);
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-100: oklch(93.2% 0.032 255.585);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-300: oklch(80.9% 0.105 251.813);
    --color-blue-400: oklch(70.7% 0.165 254.624);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-800: oklch(42.4% 0.199 265.638);
    --color-blue-900: oklch(37.9% 0.146 265.522);
    --color-indigo-400: oklch(67.3% 0.182 276.935);
    --color-indigo-500: oklch(58.5% 0.233 277.117);
    --color-indigo-600: oklch(51.1% 0.262 276.966);
    --color-violet-50: oklch(96.9% 0.016 293.756);
    --color-violet-200: oklch(89.4% 0.057 293.283);
    --color-violet-400: oklch(70.2% 0.183 293.541);
    --color-violet-500: oklch(60.6% 0.25 292.717);
    --color-violet-600: oklch(54.1% 0.281 293.009);
    --color-violet-700: oklch(49.1% 0.27 292.581);
    --color-purple-50: oklch(97.7% 0.014 308.299);
    --color-purple-200: oklch(90.2% 0.063 306.703);
    --color-purple-300: oklch(82.7% 0.119 306.383);
    --color-purple-400: oklch(71.4% 0.203 305.504);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-purple-600: oklch(55.8% 0.288 302.321);
    --color-purple-700: oklch(49.6% 0.265 301.924);
    --color-purple-800: oklch(43.8% 0.218 303.724);
    --color-purple-900: oklch(38.1% 0.176 304.987);
    --color-purple-950: oklch(29.1% 0.149 302.717);
    --color-slate-50: oklch(98.4% 0.003 247.858);
    --color-slate-100: oklch(96.8% 0.007 247.896);
    --color-slate-200: oklch(92.9% 0.013 255.508);
    --color-slate-300: oklch(86.9% 0.022 252.894);
    --color-slate-400: oklch(70.4% 0.04 256.788);
    --color-slate-500: oklch(55.4% 0.046 257.417);
    --color-slate-600: oklch(44.6% 0.043 257.281);
    --color-slate-700: oklch(37.2% 0.044 257.287);
    --color-slate-800: oklch(27.9% 0.041 260.031);
    --color-slate-900: oklch(20.8% 0.042 265.755);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --text-7xl: 4.5rem;
    --text-7xl--line-height: 1;
    --text-8xl: 6rem;
    --text-8xl--line-height: 1;
    --text-9xl: 8rem;
    --text-9xl--line-height: 1;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --font-weight-black: 900;
    --tracking-tighter: -0.05em;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-relaxed: 1.625;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);
    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);
    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-sm: 8px;
    --blur-md: 12px;
    --blur-xl: 24px;
    --blur-2xl: 40px;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-background: var(--background);
    --color-foreground: var(--foreground);
    --color-card: var(--card);
    --color-card-foreground: var(--card-foreground);
    --color-popover: var(--popover);
    --color-primary: var(--primary);
    --color-primary-foreground: var(--primary-foreground);
    --color-secondary: var(--secondary);
    --color-accent: var(--accent);
    --color-accent-foreground: var(--accent-foreground);
    --color-muted: var(--muted);
    --color-muted-foreground: var(--muted-foreground);
    --color-border: var(--border);
    --color-destructive: var(--destructive);
    --color-sidebar-bg: var(--sidebar);
    --color-sidebar-foreground: var(--sidebar-foreground);
    --color-sidebar-primary: var(--sidebar-primary);
    --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
    --color-sidebar-accent: var(--sidebar-accent);
    --color-sidebar-border: var(--sidebar-border);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .inset-6 {
    inset: calc(var(--spacing) * 6);
  }
  .inset-12 {
    inset: calc(var(--spacing) * 12);
  }
  .start {
    inset-inline-start: var(--spacing);
  }
  .end {
    inset-inline-end: var(--spacing);
  }
  .-top-8 {
    top: calc(var(--spacing) * -8);
  }
  .-top-10 {
    top: calc(var(--spacing) * -10);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .top-6 {
    top: calc(var(--spacing) * 6);
  }
  .top-8 {
    top: calc(var(--spacing) * 8);
  }
  .top-24 {
    top: calc(var(--spacing) * 24);
  }
  .top-full {
    top: 100%;
  }
  .-right-1 {
    right: calc(var(--spacing) * -1);
  }
  .-right-2 {
    right: calc(var(--spacing) * -2);
  }
  .-right-8 {
    right: calc(var(--spacing) * -8);
  }
  .-right-10 {
    right: calc(var(--spacing) * -10);
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-1\\.5 {
    right: calc(var(--spacing) * 1.5);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .right-6 {
    right: calc(var(--spacing) * 6);
  }
  .-bottom-1 {
    bottom: calc(var(--spacing) * -1);
  }
  .-bottom-2 {
    bottom: calc(var(--spacing) * -2);
  }
  .-bottom-6 {
    bottom: calc(var(--spacing) * -6);
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-3 {
    bottom: calc(var(--spacing) * 3);
  }
  .bottom-8 {
    bottom: calc(var(--spacing) * 8);
  }
  .bottom-12 {
    bottom: calc(var(--spacing) * 12);
  }
  .-left-6 {
    left: calc(var(--spacing) * -6);
  }
  .-left-\\[21px\\] {
    left: calc(21px * -1);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-3 {
    left: calc(var(--spacing) * 3);
  }
  .left-3\\.5 {
    left: calc(var(--spacing) * 3.5);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .left-8 {
    left: calc(var(--spacing) * 8);
  }
  .left-14 {
    left: calc(var(--spacing) * 14);
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-30 {
    z-index: 30;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[49\\] {
    z-index: 49;
  }
  .z-\\[60\\] {
    z-index: 60;
  }
  .z-\\[1000\\] {
    z-index: 1000;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .\\!m-0 {
    margin: calc(var(--spacing) * 0) !important;
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .-mx-4 {
    margin-inline: calc(var(--spacing) * -4);
  }
  .-mx-6 {
    margin-inline: calc(var(--spacing) * -6);
  }
  .mx-0 {
    margin-inline: calc(var(--spacing) * 0);
  }
  .mx-1 {
    margin-inline: calc(var(--spacing) * 1);
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-3 {
    margin-inline: calc(var(--spacing) * 3);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .\\!mt-0 {
    margin-top: calc(var(--spacing) * 0) !important;
  }
  .\\!mt-6 {
    margin-top: calc(var(--spacing) * 6) !important;
  }
  .\\!mt-8 {
    margin-top: calc(var(--spacing) * 8) !important;
  }
  .-mt-2 {
    margin-top: calc(var(--spacing) * -2);
  }
  .-mt-4 {
    margin-top: calc(var(--spacing) * -4);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-2\\.5 {
    margin-top: calc(var(--spacing) * 2.5);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-auto {
    margin-top: auto;
  }
  .\\!mr-0 {
    margin-right: calc(var(--spacing) * 0) !important;
  }
  .-mr-1 {
    margin-right: calc(var(--spacing) * -1);
  }
  .mr-0 {
    margin-right: calc(var(--spacing) * 0);
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .\\!mb-0 {
    margin-bottom: calc(var(--spacing) * 0) !important;
  }
  .-mb-px {
    margin-bottom: -1px;
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-1\\.5 {
    margin-bottom: calc(var(--spacing) * 1.5);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-2\\.5 {
    margin-bottom: calc(var(--spacing) * 2.5);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-3\\.5 {
    margin-bottom: calc(var(--spacing) * 3.5);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-7 {
    margin-bottom: calc(var(--spacing) * 7);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10);
  }
  .mb-12 {
    margin-bottom: calc(var(--spacing) * 12);
  }
  .mb-14 {
    margin-bottom: calc(var(--spacing) * 14);
  }
  .mb-16 {
    margin-bottom: calc(var(--spacing) * 16);
  }
  .\\!ml-auto {
    margin-left: auto !important;
  }
  .-ml-1 {
    margin-left: calc(var(--spacing) * -1);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-1\\.5 {
    margin-left: calc(var(--spacing) * 1.5);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .ml-5 {
    margin-left: calc(var(--spacing) * 5);
  }
  .ml-6 {
    margin-left: calc(var(--spacing) * 6);
  }
  .ml-auto {
    margin-left: auto;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-\\[1\\.414\\/1\\] {
    aspect-ratio: 1.414/1;
  }
  .aspect-video {
    aspect-ratio: var(--aspect-video);
  }
  .\\!h-11 {
    height: calc(var(--spacing) * 11) !important;
  }
  .\\!h-auto {
    height: auto !important;
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-11 {
    height: calc(var(--spacing) * 11);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-44 {
    height: calc(var(--spacing) * 44);
  }
  .h-48 {
    height: calc(var(--spacing) * 48);
  }
  .h-56 {
    height: calc(var(--spacing) * 56);
  }
  .h-64 {
    height: calc(var(--spacing) * 64);
  }
  .h-\\[3px\\] {
    height: 3px;
  }
  .h-\\[18px\\] {
    height: 18px;
  }
  .h-\\[26px\\] {
    height: 26px;
  }
  .h-\\[38px\\] {
    height: 38px;
  }
  .h-\\[58vh\\] {
    height: 58vh;
  }
  .h-\\[60px\\] {
    height: 60px;
  }
  .h-\\[60vh\\] {
    height: 60vh;
  }
  .h-\\[400px\\] {
    height: 400px;
  }
  .h-\\[calc\\(100vh-112px\\)\\] {
    height: calc(100vh - 112px);
  }
  .h-\\[calc\\(100vh-140px\\)\\] {
    height: calc(100vh - 140px);
  }
  .h-auto {
    height: auto;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .h-screen {
    height: 100vh;
  }
  .max-h-40 {
    max-height: calc(var(--spacing) * 40);
  }
  .max-h-56 {
    max-height: calc(var(--spacing) * 56);
  }
  .max-h-64 {
    max-height: calc(var(--spacing) * 64);
  }
  .max-h-72 {
    max-height: calc(var(--spacing) * 72);
  }
  .max-h-80 {
    max-height: calc(var(--spacing) * 80);
  }
  .max-h-\\[60vh\\] {
    max-height: 60vh;
  }
  .max-h-\\[70vh\\] {
    max-height: 70vh;
  }
  .max-h-\\[180px\\] {
    max-height: 180px;
  }
  .max-h-\\[200px\\] {
    max-height: 200px;
  }
  .max-h-\\[280px\\] {
    max-height: 280px;
  }
  .max-h-\\[320px\\] {
    max-height: 320px;
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0);
  }
  .min-h-\\[100px\\] {
    min-height: 100px;
  }
  .min-h-\\[300px\\] {
    min-height: 300px;
  }
  .min-h-\\[calc\\(100vh-60px\\)\\] {
    min-height: calc(100vh - 60px);
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-0\\.5 {
    width: calc(var(--spacing) * 0.5);
  }
  .w-1 {
    width: calc(var(--spacing) * 1);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-14 {
    width: calc(var(--spacing) * 14);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-28 {
    width: calc(var(--spacing) * 28);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-44 {
    width: calc(var(--spacing) * 44);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-\\[3px\\] {
    width: 3px;
  }
  .w-\\[44px\\] {
    width: 44px;
  }
  .w-\\[64px\\] {
    width: 64px;
  }
  .w-\\[72px\\] {
    width: 72px;
  }
  .w-\\[76px\\] {
    width: 76px;
  }
  .w-\\[250px\\] {
    width: 250px;
  }
  .w-\\[280px\\] {
    width: 280px;
  }
  .w-\\[400px\\] {
    width: 400px;
  }
  .w-\\[calc\\(100\\%-32px\\)\\] {
    width: calc(100% - 32px);
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-px {
    width: 1px;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-6xl {
    max-width: var(--container-6xl);
  }
  .max-w-7xl {
    max-width: var(--container-7xl);
  }
  .max-w-\\[120px\\] {
    max-width: 120px;
  }
  .max-w-\\[180px\\] {
    max-width: 180px;
  }
  .max-w-\\[200px\\] {
    max-width: 200px;
  }
  .max-w-\\[380px\\] {
    max-width: 380px;
  }
  .max-w-\\[680px\\] {
    max-width: 680px;
  }
  .max-w-\\[760px\\] {
    max-width: 760px;
  }
  .max-w-\\[1400px\\] {
    max-width: 1400px;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-\\[18px\\] {
    min-width: 18px;
  }
  .min-w-\\[20px\\] {
    min-width: 20px;
  }
  .min-w-\\[120px\\] {
    min-width: 120px;
  }
  .min-w-\\[140px\\] {
    min-width: 140px;
  }
  .min-w-\\[170px\\] {
    min-width: 170px;
  }
  .min-w-\\[190px\\] {
    min-width: 190px;
  }
  .min-w-\\[640px\\] {
    min-width: 640px;
  }
  .min-w-\\[1200px\\] {
    min-width: 1200px;
  }
  .flex-1 {
    flex: 1 1;
  }
  .flex-\\[2\\] {
    flex: 2 1;
  }
  .flex-shrink {
    flex-shrink: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-90 {
    --tw-scale-x: 90%;
    --tw-scale-y: 90%;
    --tw-scale-z: 90%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-110 {
    --tw-scale-x: 110%;
    --tw-scale-y: 110%;
    --tw-scale-z: 110%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-\\[1fr_1fr_1fr_1fr_35px\\] {
    grid-template-columns: 1fr 1fr 1fr 1fr 35px;
  }
  .grid-cols-\\[1fr_1fr_1fr_1fr_40px\\] {
    grid-template-columns: 1fr 1fr 1fr 1fr 40px;
  }
  .grid-cols-\\[minmax\\(160px\\,1fr\\)_200px_160px_180px\\] {
    grid-template-columns: minmax(160px,1fr) 200px 160px 180px;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0);
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10);
  }
  .gap-14 {
    gap: calc(var(--spacing) * 14);
  }
  .space-y-0 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-0\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-12 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 12) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 12) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-1\\.5 {
    column-gap: calc(var(--spacing) * 1.5);
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-x-4 {
    column-gap: calc(var(--spacing) * 4);
  }
  .gap-x-6 {
    column-gap: calc(var(--spacing) * 6);
  }
  .gap-x-8 {
    column-gap: calc(var(--spacing) * 8);
  }
  .gap-y-0 {
    row-gap: calc(var(--spacing) * 0);
  }
  .gap-y-0\\.5 {
    row-gap: calc(var(--spacing) * 0.5);
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .gap-y-3 {
    row-gap: calc(var(--spacing) * 3);
  }
  .gap-y-5 {
    row-gap: calc(var(--spacing) * 5);
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-border {
    :where(& > :not(:last-child)) {
      border-color: var(--color-border);
    }
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-y-hidden {
    overflow-y: hidden;
  }
  .\\!rounded-full {
    border-radius: calc(infinity * 1px) !important;
  }
  .\\!rounded-md {
    border-radius: var(--radius-md) !important;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-\\[10px\\] {
    border-radius: 10px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-t-xl {
    border-top-left-radius: var(--radius-xl);
    border-top-right-radius: var(--radius-xl);
  }
  .rounded-l-lg {
    border-top-left-radius: var(--radius-lg);
    border-bottom-left-radius: var(--radius-lg);
  }
  .rounded-r-full {
    border-top-right-radius: calc(infinity * 1px);
    border-bottom-right-radius: calc(infinity * 1px);
  }
  .\\!border-0 {
    border-style: var(--tw-border-style) !important;
    border-width: 0px !important;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-4 {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-l-2 {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-l-4 {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-amber-200 {
    border-color: var(--color-amber-200);
  }
  .border-amber-300 {
    border-color: var(--color-amber-300);
  }
  .border-amber-500\\/20 {
    border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-amber-500) 20%, transparent);
    }
  }
  .border-background {
    border-color: var(--color-background);
  }
  .border-blue-100 {
    border-color: var(--color-blue-100);
  }
  .border-blue-200 {
    border-color: var(--color-blue-200);
  }
  .border-border {
    border-color: var(--color-border);
  }
  .border-border\\/10 {
    border-color: var(--color-border);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-border) 10%, transparent);
    }
  }
  .border-border\\/20 {
    border-color: var(--color-border);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-border) 20%, transparent);
    }
  }
  .border-border\\/40 {
    border-color: var(--color-border);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-border) 40%, transparent);
    }
  }
  .border-border\\/50 {
    border-color: var(--color-border);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-border) 50%, transparent);
    }
  }
  .border-border\\/60 {
    border-color: var(--color-border);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-border) 60%, transparent);
    }
  }
  .border-cyan-200 {
    border-color: var(--color-cyan-200);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-green-100 {
    border-color: var(--color-green-100);
  }
  .border-green-200 {
    border-color: var(--color-green-200);
  }
  .border-orange-200 {
    border-color: var(--color-orange-200);
  }
  .border-orange-500 {
    border-color: var(--color-orange-500);
  }
  .border-orange-500\\/20 {
    border-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-orange-500) 20%, transparent);
    }
  }
  .border-primary {
    border-color: var(--color-primary);
  }
  .border-primary\\/15 {
    border-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 15%, transparent);
    }
  }
  .border-primary\\/20 {
    border-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 20%, transparent);
    }
  }
  .border-primary\\/25 {
    border-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 25%, transparent);
    }
  }
  .border-primary\\/40 {
    border-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 40%, transparent);
    }
  }
  .border-purple-200 {
    border-color: var(--color-purple-200);
  }
  .border-purple-600 {
    border-color: var(--color-purple-600);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-sidebar-border {
    border-color: var(--color-sidebar-border);
  }
  .border-sky-700 {
    border-color: var(--color-sky-700);
  }
  .border-slate-100 {
    border-color: var(--color-slate-100);
  }
  .border-slate-200 {
    border-color: var(--color-slate-200);
  }
  .border-slate-300 {
    border-color: var(--color-slate-300);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-violet-200 {
    border-color: var(--color-violet-200);
  }
  .border-white {
    border-color: var(--color-white);
  }
  .border-white\\/5 {
    border-color: color-mix(in srgb, #fff 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
  }
  .border-white\\/30 {
    border-color: color-mix(in srgb, #fff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
  }
  .border-white\\/80 {
    border-color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .border-l-amber-400 {
    border-left-color: var(--color-amber-400);
  }
  .border-l-indigo-500 {
    border-left-color: var(--color-indigo-500);
  }
  .border-l-orange-400 {
    border-left-color: var(--color-orange-400);
  }
  .border-l-slate-400 {
    border-left-color: var(--color-slate-400);
  }
  .\\!bg-muted\\/60 {
    background-color: var(--color-muted) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 60%, transparent) !important;
    }
  }
  .bg-accent {
    background-color: var(--color-accent);
  }
  .bg-accent\\/20 {
    background-color: var(--color-accent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-accent) 20%, transparent);
    }
  }
  .bg-accent\\/30 {
    background-color: var(--color-accent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-accent) 30%, transparent);
    }
  }
  .bg-accent\\/50 {
    background-color: var(--color-accent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
    }
  }
  .bg-amber-50 {
    background-color: var(--color-amber-50);
  }
  .bg-amber-50\\/40 {
    background-color: color-mix(in srgb, oklch(98.7% 0.022 95.277) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-50) 40%, transparent);
    }
  }
  .bg-amber-100 {
    background-color: var(--color-amber-100);
  }
  .bg-amber-400 {
    background-color: var(--color-amber-400);
  }
  .bg-amber-500\\/5 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 5%, transparent);
    }
  }
  .bg-background {
    background-color: var(--color-background);
  }
  .bg-background\\/50 {
    background-color: var(--color-background);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-background) 50%, transparent);
    }
  }
  .bg-background\\/95 {
    background-color: var(--color-background);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-background) 95%, transparent);
    }
  }
  .bg-black\\/0 {
    background-color: color-mix(in srgb, #000 0%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 0%, transparent);
    }
  }
  .bg-black\\/25 {
    background-color: color-mix(in srgb, #000 25%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 25%, transparent);
    }
  }
  .bg-black\\/30 {
    background-color: color-mix(in srgb, #000 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 30%, transparent);
    }
  }
  .bg-black\\/40 {
    background-color: color-mix(in srgb, #000 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 40%, transparent);
    }
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-black\\/60 {
    background-color: color-mix(in srgb, #000 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 60%, transparent);
    }
  }
  .bg-blue-50 {
    background-color: var(--color-blue-50);
  }
  .bg-blue-50\\/30 {
    background-color: color-mix(in srgb, oklch(97% 0.014 254.604) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-50) 30%, transparent);
    }
  }
  .bg-blue-50\\/50 {
    background-color: color-mix(in srgb, oklch(97% 0.014 254.604) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-50) 50%, transparent);
    }
  }
  .bg-blue-100 {
    background-color: var(--color-blue-100);
  }
  .bg-blue-100\\/50 {
    background-color: color-mix(in srgb, oklch(93.2% 0.032 255.585) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-100) 50%, transparent);
    }
  }
  .bg-blue-200 {
    background-color: var(--color-blue-200);
  }
  .bg-blue-600 {
    background-color: var(--color-blue-600);
  }
  .bg-border {
    background-color: var(--color-border);
  }
  .bg-card {
    background-color: var(--color-card);
  }
  .bg-card\\/50 {
    background-color: var(--color-card);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-card) 50%, transparent);
    }
  }
  .bg-card\\/90 {
    background-color: var(--color-card);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-card) 90%, transparent);
    }
  }
  .bg-cyan-50 {
    background-color: var(--color-cyan-50);
  }
  .bg-destructive {
    background-color: var(--color-destructive);
  }
  .bg-emerald-50\\/60 {
    background-color: color-mix(in srgb, oklch(97.9% 0.021 166.113) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-emerald-50) 60%, transparent);
    }
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-500 {
    background-color: var(--color-gray-500);
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-green-50\\/30 {
    background-color: color-mix(in srgb, oklch(98.2% 0.018 155.826) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-50) 30%, transparent);
    }
  }
  .bg-green-100 {
    background-color: var(--color-green-100);
  }
  .bg-green-500 {
    background-color: var(--color-green-500);
  }
  .bg-green-500\\/5 {
    background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-500) 5%, transparent);
    }
  }
  .bg-muted {
    background-color: var(--color-muted);
  }
  .bg-muted-foreground\\/40 {
    background-color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted-foreground) 40%, transparent);
    }
  }
  .bg-muted\\/5 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 5%, transparent);
    }
  }
  .bg-muted\\/10 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 10%, transparent);
    }
  }
  .bg-muted\\/20 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 20%, transparent);
    }
  }
  .bg-muted\\/30 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 30%, transparent);
    }
  }
  .bg-muted\\/40 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 40%, transparent);
    }
  }
  .bg-muted\\/50 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 50%, transparent);
    }
  }
  .bg-muted\\/60 {
    background-color: var(--color-muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 60%, transparent);
    }
  }
  .bg-orange-50 {
    background-color: var(--color-orange-50);
  }
  .bg-orange-50\\/30 {
    background-color: color-mix(in srgb, oklch(98% 0.016 73.684) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-orange-50) 30%, transparent);
    }
  }
  .bg-orange-100 {
    background-color: var(--color-orange-100);
  }
  .bg-orange-500 {
    background-color: var(--color-orange-500);
  }
  .bg-orange-500\\/10 {
    background-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-orange-500) 10%, transparent);
    }
  }
  .bg-orange-500\\/20 {
    background-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-orange-500) 20%, transparent);
    }
  }
  .bg-orange-600 {
    background-color: var(--color-orange-600);
  }
  .bg-popover {
    background-color: var(--color-popover);
  }
  .bg-primary {
    background-color: var(--color-primary);
  }
  .bg-primary\\/5 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 5%, transparent);
    }
  }
  .bg-primary\\/10 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 10%, transparent);
    }
  }
  .bg-primary\\/12 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 12%, transparent);
    }
  }
  .bg-primary\\/15 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 15%, transparent);
    }
  }
  .bg-primary\\/18 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 18%, transparent);
    }
  }
  .bg-primary\\/20 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 20%, transparent);
    }
  }
  .bg-primary\\/30 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
    }
  }
  .bg-primary\\/40 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 40%, transparent);
    }
  }
  .bg-primary\\/50 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 50%, transparent);
    }
  }
  .bg-primary\\/60 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 60%, transparent);
    }
  }
  .bg-purple-50 {
    background-color: var(--color-purple-50);
  }
  .bg-purple-500\\/5 {
    background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-purple-500) 5%, transparent);
    }
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-400 {
    background-color: var(--color-red-400);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-red-500\\/10 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 10%, transparent);
    }
  }
  .bg-red-600 {
    background-color: var(--color-red-600);
  }
  .bg-secondary {
    background-color: var(--color-secondary);
  }
  .bg-secondary\\/5 {
    background-color: var(--color-secondary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-secondary) 5%, transparent);
    }
  }
  .bg-sidebar-accent {
    background-color: var(--color-sidebar-accent);
  }
  .bg-sidebar-accent\\/40 {
    background-color: var(--color-sidebar-accent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-sidebar-accent) 40%, transparent);
    }
  }
  .bg-sidebar-bg\\/30 {
    background-color: var(--color-sidebar-bg);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-sidebar-bg) 30%, transparent);
    }
  }
  .bg-sidebar-bg\\/50 {
    background-color: var(--color-sidebar-bg);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-sidebar-bg) 50%, transparent);
    }
  }
  .bg-sidebar-primary {
    background-color: var(--color-sidebar-primary);
  }
  .bg-sky-700 {
    background-color: var(--color-sky-700);
  }
  .bg-slate-50 {
    background-color: var(--color-slate-50);
  }
  .bg-slate-100\\/80 {
    background-color: color-mix(in srgb, oklch(96.8% 0.007 247.896) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-100) 80%, transparent);
    }
  }
  .bg-slate-900\\/20 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 20%, transparent);
    }
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-violet-50 {
    background-color: var(--color-violet-50);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/5 {
    background-color: color-mix(in srgb, #fff 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
  }
  .bg-white\\/10 {
    background-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .bg-white\\/15 {
    background-color: color-mix(in srgb, #fff 15%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 15%, transparent);
    }
  }
  .bg-white\\/20 {
    background-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
  }
  .bg-yellow-50 {
    background-color: var(--color-yellow-50);
  }
  .bg-gradient-to-br {
    --tw-gradient-position: to bottom right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-r {
    --tw-gradient-position: to right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .from-blue-100 {
    --tw-gradient-from: var(--color-blue-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-blue-600 {
    --tw-gradient-from: var(--color-blue-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-gray-900 {
    --tw-gradient-from: var(--color-gray-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-indigo-600 {
    --tw-gradient-from: var(--color-indigo-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-orange-50 {
    --tw-gradient-from: var(--color-orange-50);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-primary\\/5 {
    --tw-gradient-from: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-primary) 5%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .via-gray-800 {
    --tw-gradient-via: var(--color-gray-800);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-violet-600 {
    --tw-gradient-via: var(--color-violet-600);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .to-amber-50 {
    --tw-gradient-to: var(--color-amber-50);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-gray-900 {
    --tw-gradient-to: var(--color-gray-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-purple-600 {
    --tw-gradient-to: var(--color-purple-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-sky-500 {
    --tw-gradient-to: var(--color-sky-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-transparent {
    --tw-gradient-to: transparent;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-white {
    --tw-gradient-to: var(--color-white);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-center {
    background-position: center;
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .\\!p-0 {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-7 {
    padding: calc(var(--spacing) * 7);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-10 {
    padding: calc(var(--spacing) * 10);
  }
  .p-20 {
    padding: calc(var(--spacing) * 20);
  }
  .\\!px-1 {
    padding-inline: calc(var(--spacing) * 1) !important;
  }
  .\\!px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5) !important;
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-0\\.5 {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10);
  }
  .\\!py-0 {
    padding-block: calc(var(--spacing) * 0) !important;
  }
  .\\!py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5) !important;
  }
  .py-0 {
    padding-block: calc(var(--spacing) * 0);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-3\\.5 {
    padding-block: calc(var(--spacing) * 3.5);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-7 {
    padding-block: calc(var(--spacing) * 7);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-10 {
    padding-block: calc(var(--spacing) * 10);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-14 {
    padding-block: calc(var(--spacing) * 14);
  }
  .py-16 {
    padding-block: calc(var(--spacing) * 16);
  }
  .py-20 {
    padding-block: calc(var(--spacing) * 20);
  }
  .py-24 {
    padding-block: calc(var(--spacing) * 24);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-2\\.5 {
    padding-top: calc(var(--spacing) * 2.5);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-3\\.5 {
    padding-top: calc(var(--spacing) * 3.5);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-12 {
    padding-top: calc(var(--spacing) * 12);
  }
  .pt-24 {
    padding-top: calc(var(--spacing) * 24);
  }
  .pr-1 {
    padding-right: calc(var(--spacing) * 1);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-24 {
    padding-right: calc(var(--spacing) * 24);
  }
  .pb-0\\.5 {
    padding-bottom: calc(var(--spacing) * 0.5);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-2\\.5 {
    padding-bottom: calc(var(--spacing) * 2.5);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-16 {
    padding-bottom: calc(var(--spacing) * 16);
  }
  .pl-0 {
    padding-left: calc(var(--spacing) * 0);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .pl-6 {
    padding-left: calc(var(--spacing) * 6);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .font-sans {
    font-family: var(--font-sans);
  }
  .\\!text-sm {
    font-size: var(--text-sm) !important;
    line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
  }
  .\\!text-xs {
    font-size: var(--text-xs) !important;
    line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-8xl {
    font-size: var(--text-8xl);
    line-height: var(--tw-leading, var(--text-8xl--line-height));
  }
  .text-9xl {
    font-size: var(--text-9xl);
    line-height: var(--tw-leading, var(--text-9xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .\\!text-\\[10px\\] {
    font-size: 10px !important;
  }
  .\\!text-\\[11px\\] {
    font-size: 11px !important;
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10\\.5px\\] {
    font-size: 10.5px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12\\.5px\\] {
    font-size: 12.5px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13\\.5px\\] {
    font-size: 13.5px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[14px\\] {
    font-size: 14px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .text-\\[16px\\] {
    font-size: 16px;
  }
  .\\!leading-4 {
    --tw-leading: calc(var(--spacing) * 4) !important;
    line-height: calc(var(--spacing) * 4) !important;
  }
  .leading-3 {
    --tw-leading: calc(var(--spacing) * 3);
    line-height: calc(var(--spacing) * 3);
  }
  .leading-4 {
    --tw-leading: calc(var(--spacing) * 4);
    line-height: calc(var(--spacing) * 4);
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-\\[1\\.1\\] {
    --tw-leading: 1.1;
    line-height: 1.1;
  }
  .leading-\\[14px\\] {
    --tw-leading: 14px;
    line-height: 14px;
  }
  .leading-\\[18px\\] {
    --tw-leading: 18px;
    line-height: 18px;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .\\!font-medium {
    --tw-font-weight: var(--font-weight-medium) !important;
    font-weight: var(--font-weight-medium) !important;
  }
  .font-black {
    --tw-font-weight: var(--font-weight-black);
    font-weight: var(--font-weight-black);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-light {
    --tw-font-weight: var(--font-weight-light);
    font-weight: var(--font-weight-light);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[0\\.3em\\] {
    --tw-tracking: 0.3em;
    letter-spacing: 0.3em;
  }
  .tracking-\\[0\\.22em\\] {
    --tw-tracking: 0.22em;
    letter-spacing: 0.22em;
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-tighter {
    --tw-tracking: var(--tracking-tighter);
    letter-spacing: var(--tracking-tighter);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .\\!text-muted-foreground {
    color: var(--color-muted-foreground) !important;
  }
  .\\!text-primary {
    color: var(--color-primary) !important;
  }
  .\\!text-red-700 {
    color: var(--color-red-700) !important;
  }
  .text-\\[var\\(--primary\\)\\] {
    color: var(--primary);
  }
  .text-accent-foreground {
    color: var(--color-accent-foreground);
  }
  .text-amber-500 {
    color: var(--color-amber-500);
  }
  .text-amber-600 {
    color: var(--color-amber-600);
  }
  .text-amber-700 {
    color: var(--color-amber-700);
  }
  .text-amber-800 {
    color: var(--color-amber-800);
  }
  .text-amber-800\\/80 {
    color: color-mix(in srgb, oklch(47.3% 0.137 46.201) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-amber-800) 80%, transparent);
    }
  }
  .text-amber-900 {
    color: var(--color-amber-900);
  }
  .text-blue-100 {
    color: var(--color-blue-100);
  }
  .text-blue-200 {
    color: var(--color-blue-200);
  }
  .text-blue-400 {
    color: var(--color-blue-400);
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-blue-600\\/60 {
    color: color-mix(in srgb, oklch(54.6% 0.245 262.881) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-blue-600) 60%, transparent);
    }
  }
  .text-blue-700 {
    color: var(--color-blue-700);
  }
  .text-blue-800 {
    color: var(--color-blue-800);
  }
  .text-blue-800\\/80 {
    color: color-mix(in srgb, oklch(42.4% 0.199 265.638) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-blue-800) 80%, transparent);
    }
  }
  .text-blue-900 {
    color: var(--color-blue-900);
  }
  .text-card-foreground {
    color: var(--color-card-foreground);
  }
  .text-cyan-500 {
    color: var(--color-cyan-500);
  }
  .text-cyan-700 {
    color: var(--color-cyan-700);
  }
  .text-destructive {
    color: var(--color-destructive);
  }
  .text-emerald-500 {
    color: var(--color-emerald-500);
  }
  .text-emerald-600 {
    color: var(--color-emerald-600);
  }
  .text-foreground {
    color: var(--color-foreground);
  }
  .text-foreground\\/80 {
    color: var(--color-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-foreground) 80%, transparent);
    }
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-green-700\\/50 {
    color: color-mix(in srgb, oklch(52.7% 0.154 150.069) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-green-700) 50%, transparent);
    }
  }
  .text-indigo-500 {
    color: var(--color-indigo-500);
  }
  .text-indigo-600 {
    color: var(--color-indigo-600);
  }
  .text-muted-foreground {
    color: var(--color-muted-foreground);
  }
  .text-muted-foreground\\/20 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 20%, transparent);
    }
  }
  .text-muted-foreground\\/30 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 30%, transparent);
    }
  }
  .text-muted-foreground\\/40 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 40%, transparent);
    }
  }
  .text-muted-foreground\\/50 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 50%, transparent);
    }
  }
  .text-muted-foreground\\/60 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 60%, transparent);
    }
  }
  .text-muted-foreground\\/70 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 70%, transparent);
    }
  }
  .text-muted-foreground\\/80 {
    color: var(--color-muted-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-muted-foreground) 80%, transparent);
    }
  }
  .text-orange-200 {
    color: var(--color-orange-200);
  }
  .text-orange-300 {
    color: var(--color-orange-300);
  }
  .text-orange-400 {
    color: var(--color-orange-400);
  }
  .text-orange-400\\/70 {
    color: color-mix(in srgb, oklch(75% 0.183 55.934) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-orange-400) 70%, transparent);
    }
  }
  .text-orange-500 {
    color: var(--color-orange-500);
  }
  .text-orange-600 {
    color: var(--color-orange-600);
  }
  .text-orange-700 {
    color: var(--color-orange-700);
  }
  .text-orange-800\\/80 {
    color: color-mix(in srgb, oklch(47% 0.157 37.304) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-orange-800) 80%, transparent);
    }
  }
  .text-orange-900 {
    color: var(--color-orange-900);
  }
  .text-primary {
    color: var(--color-primary);
  }
  .text-primary-foreground {
    color: var(--color-primary-foreground);
  }
  .text-purple-500 {
    color: var(--color-purple-500);
  }
  .text-purple-600 {
    color: var(--color-purple-600);
  }
  .text-purple-700 {
    color: var(--color-purple-700);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-secondary {
    color: var(--color-secondary);
  }
  .text-sidebar-foreground {
    color: var(--color-sidebar-foreground);
  }
  .text-sidebar-foreground\\/35 {
    color: var(--color-sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-sidebar-foreground) 35%, transparent);
    }
  }
  .text-sidebar-foreground\\/40 {
    color: var(--color-sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-sidebar-foreground) 40%, transparent);
    }
  }
  .text-sidebar-foreground\\/45 {
    color: var(--color-sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-sidebar-foreground) 45%, transparent);
    }
  }
  .text-sidebar-foreground\\/55 {
    color: var(--color-sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-sidebar-foreground) 55%, transparent);
    }
  }
  .text-sidebar-foreground\\/60 {
    color: var(--color-sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-sidebar-foreground) 60%, transparent);
    }
  }
  .text-sidebar-foreground\\/70 {
    color: var(--color-sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-sidebar-foreground) 70%, transparent);
    }
  }
  .text-sidebar-primary {
    color: var(--color-sidebar-primary);
  }
  .text-sidebar-primary-foreground {
    color: var(--color-sidebar-primary-foreground);
  }
  .text-slate-200 {
    color: var(--color-slate-200);
  }
  .text-slate-400 {
    color: var(--color-slate-400);
  }
  .text-slate-500 {
    color: var(--color-slate-500);
  }
  .text-slate-600 {
    color: var(--color-slate-600);
  }
  .text-slate-800 {
    color: var(--color-slate-800);
  }
  .text-violet-500 {
    color: var(--color-violet-500);
  }
  .text-violet-700 {
    color: var(--color-violet-700);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\/60 {
    color: color-mix(in srgb, #fff 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 60%, transparent);
    }
  }
  .text-white\\/70 {
    color: color-mix(in srgb, #fff 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .text-white\\/75 {
    color: color-mix(in srgb, #fff 75%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 75%, transparent);
    }
  }
  .text-white\\/80 {
    color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .text-white\\/85 {
    color: color-mix(in srgb, #fff 85%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 85%, transparent);
    }
  }
  .text-white\\/90 {
    color: color-mix(in srgb, #fff 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 90%, transparent);
    }
  }
  .text-yellow-300 {
    color: var(--color-yellow-300);
  }
  .text-yellow-500 {
    color: var(--color-yellow-500);
  }
  .text-yellow-600 {
    color: var(--color-yellow-600);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .ordinal {
    --tw-ordinal: ordinal;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-2 {
    text-underline-offset: 2px;
  }
  .placeholder-gray-400 {
    &::placeholder {
      color: var(--color-gray-400);
    }
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-30 {
    opacity: 30%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .opacity-\\[0\\.03\\] {
    opacity: 0.03;
  }
  .opacity-\\[0\\.12\\] {
    opacity: 0.12;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_0_8px_rgba\\(239\\,68\\,68\\,0\\.8\\)\\] {
    --tw-shadow: 0 0 8px var(--tw-shadow-color, rgba(239,68,68,0.8));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-inner {
    --tw-shadow: inset 0 2px 4px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-blue-500\\/20 {
    --tw-shadow-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-blue-500) 20%, transparent) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-orange-900\\/20 {
    --tw-shadow-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-orange-900) 20%, transparent) var(--tw-shadow-alpha), transparent);
    }
  }
  .ring-primary {
    --tw-ring-color: var(--color-primary);
  }
  .ring-primary\\/30 {
    --tw-ring-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
    }
  }
  .ring-white {
    --tw-ring-color: var(--color-white);
  }
  .ring-white\\/5 {
    --tw-ring-color: color-mix(in srgb, #fff 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .blur-2xl {
    --tw-blur: blur(var(--blur-2xl));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-md {
    --tw-drop-shadow-size: drop-shadow(0 3px 3px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.12)));
    --tw-drop-shadow: drop-shadow(var(--drop-shadow-md));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-sm {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.15)));
    --tw-drop-shadow: drop-shadow(var(--drop-shadow-sm));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-xl {
    --tw-drop-shadow-size: drop-shadow(0 9px 7px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.1)));
    --tw-drop-shadow: drop-shadow(var(--drop-shadow-xl));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur {
    --tw-backdrop-blur: blur(8px);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-md {
    --tw-backdrop-blur: blur(var(--blur-md));
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-xl {
    --tw-backdrop-blur: blur(var(--blur-xl));
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[margin\\] {
    transition-property: margin;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\,transform\\] {
    transition-property: width,transform;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-all {
    -webkit-user-select: all;
    user-select: all;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .group-hover\\:scale-105 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 105%;
        --tw-scale-y: 105%;
        --tw-scale-z: 105%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .group-hover\\:scale-110 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 110%;
        --tw-scale-y: 110%;
        --tw-scale-z: 110%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .group-hover\\:scale-125 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 125%;
        --tw-scale-y: 125%;
        --tw-scale-z: 125%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .group-hover\\:bg-black\\/20 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #000 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-black) 20%, transparent);
        }
      }
    }
  }
  .group-hover\\:text-indigo-600 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-indigo-600);
      }
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .placeholder\\:text-muted-foreground {
    &::placeholder {
      color: var(--color-muted-foreground);
    }
  }
  .last\\:border-0 {
    &:last-child {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .last\\:border-r-0 {
    &:last-child {
      border-right-style: var(--tw-border-style);
      border-right-width: 0px;
    }
  }
  .last\\:pb-0 {
    &:last-child {
      padding-bottom: calc(var(--spacing) * 0);
    }
  }
  .focus-within\\:ring-blue-500\\/50 {
    &:focus-within {
      --tw-ring-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-blue-500) 50%, transparent);
      }
    }
  }
  .hover\\:-translate-y-0\\.5 {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .hover\\:-translate-y-1 {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -1);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .hover\\:-translate-y-2 {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -2);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .hover\\:scale-110 {
    &:hover {
      @media (hover: hover) {
        --tw-scale-x: 110%;
        --tw-scale-y: 110%;
        --tw-scale-z: 110%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .hover\\:scale-\\[1\\.02\\] {
    &:hover {
      @media (hover: hover) {
        scale: 1.02;
      }
    }
  }
  .hover\\:border-blue-300 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-blue-300);
      }
    }
  }
  .hover\\:border-muted-foreground {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-muted-foreground);
      }
    }
  }
  .hover\\:border-primary {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary);
      }
    }
  }
  .hover\\:border-primary\\/30 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
        }
      }
    }
  }
  .hover\\:border-primary\\/40 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-primary) 40%, transparent);
        }
      }
    }
  }
  .hover\\:border-primary\\/50 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-primary) 50%, transparent);
        }
      }
    }
  }
  .hover\\:border-purple-700 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-purple-700);
      }
    }
  }
  .hover\\:bg-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-accent);
      }
    }
  }
  .hover\\:bg-accent\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-accent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-accent) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-accent\\/30 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-accent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-accent) 30%, transparent);
        }
      }
    }
  }
  .hover\\:bg-black\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #000 10%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-black) 10%, transparent);
        }
      }
    }
  }
  .hover\\:bg-blue-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-50);
      }
    }
  }
  .hover\\:bg-blue-500 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-500);
      }
    }
  }
  .hover\\:bg-muted {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
      }
    }
  }
  .hover\\:bg-muted\\/5 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-muted) 5%, transparent);
        }
      }
    }
  }
  .hover\\:bg-muted\\/30 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-muted) 30%, transparent);
        }
      }
    }
  }
  .hover\\:bg-muted\\/40 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-muted) 40%, transparent);
        }
      }
    }
  }
  .hover\\:bg-muted\\/60 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-muted) 60%, transparent);
        }
      }
    }
  }
  .hover\\:bg-orange-500 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-orange-500);
      }
    }
  }
  .hover\\:bg-primary\\/90 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-primary) 90%, transparent);
        }
      }
    }
  }
  .hover\\:bg-red-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-red-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-secondary\\/50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-secondary);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-secondary) 50%, transparent);
        }
      }
    }
  }
  .hover\\:bg-sidebar-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-sidebar-accent);
      }
    }
  }
  .hover\\:bg-sky-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-sky-800);
      }
    }
  }
  .hover\\:bg-slate-50\\/60 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(98.4% 0.003 247.858) 60%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-slate-50) 60%, transparent);
        }
      }
    }
  }
  .hover\\:from-blue-200 {
    &:hover {
      @media (hover: hover) {
        --tw-gradient-from: var(--color-blue-200);
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
      }
    }
  }
  .hover\\:to-blue-50 {
    &:hover {
      @media (hover: hover) {
        --tw-gradient-to: var(--color-blue-50);
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
      }
    }
  }
  .hover\\:\\!text-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary) !important;
      }
    }
  }
  .hover\\:text-destructive {
    &:hover {
      @media (hover: hover) {
        color: var(--color-destructive);
      }
    }
  }
  .hover\\:text-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-foreground);
      }
    }
  }
  .hover\\:text-green-800 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-green-800);
      }
    }
  }
  .hover\\:text-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary);
      }
    }
  }
  .hover\\:text-purple-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-purple-700);
      }
    }
  }
  .hover\\:text-red-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-500);
      }
    }
  }
  .hover\\:text-red-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-700);
      }
    }
  }
  .hover\\:text-sidebar-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-sidebar-foreground);
      }
    }
  }
  .hover\\:text-sidebar-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-sidebar-primary);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-80 {
    &:hover {
      @media (hover: hover) {
        opacity: 80%;
      }
    }
  }
  .hover\\:opacity-90 {
    &:hover {
      @media (hover: hover) {
        opacity: 90%;
      }
    }
  }
  .hover\\:shadow-lg {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-sm {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:brightness-110 {
    &:hover {
      @media (hover: hover) {
        --tw-brightness: brightness(110%);
        filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
      }
    }
  }
  .hover\\:brightness-125 {
    &:hover {
      @media (hover: hover) {
        --tw-brightness: brightness(125%);
        filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
      }
    }
  }
  .focus\\:border-blue-400 {
    &:focus {
      border-color: var(--color-blue-400);
    }
  }
  .focus\\:ring-1 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-blue-400 {
    &:focus {
      --tw-ring-color: var(--color-blue-400);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .active\\:scale-\\[0\\.98\\] {
    &:active {
      scale: 0.98;
    }
  }
  .active\\:cursor-grabbing {
    &:active {
      cursor: grabbing;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:opacity-40 {
    &:disabled {
      opacity: 40%;
    }
  }
  .disabled\\:opacity-60 {
    &:disabled {
      opacity: 60%;
    }
  }
  .max-md\\:-mx-3 {
    @media (width < 48rem) {
      margin-inline: calc(var(--spacing) * -3);
    }
  }
  .max-md\\:rounded-xl {
    @media (width < 48rem) {
      border-radius: var(--radius-xl);
    }
  }
  .max-md\\:p-3 {
    @media (width < 48rem) {
      padding: calc(var(--spacing) * 3);
    }
  }
  .max-md\\:p-4 {
    @media (width < 48rem) {
      padding: calc(var(--spacing) * 4);
    }
  }
  .max-md\\:px-3 {
    @media (width < 48rem) {
      padding-inline: calc(var(--spacing) * 3);
    }
  }
  .max-md\\:px-4 {
    @media (width < 48rem) {
      padding-inline: calc(var(--spacing) * 4);
    }
  }
  .max-md\\:py-3 {
    @media (width < 48rem) {
      padding-block: calc(var(--spacing) * 3);
    }
  }
  .max-md\\:pt-3 {
    @media (width < 48rem) {
      padding-top: calc(var(--spacing) * 3);
    }
  }
  .max-sm\\:text-left {
    @media (width < 40rem) {
      text-align: left;
    }
  }
  .sm\\:col-span-2 {
    @media (width >= 40rem) {
      grid-column: span 2 / span 2;
    }
  }
  .sm\\:mb-10 {
    @media (width >= 40rem) {
      margin-bottom: calc(var(--spacing) * 10);
    }
  }
  .sm\\:mb-12 {
    @media (width >= 40rem) {
      margin-bottom: calc(var(--spacing) * 12);
    }
  }
  .sm\\:ml-auto {
    @media (width >= 40rem) {
      margin-left: auto;
    }
  }
  .sm\\:block {
    @media (width >= 40rem) {
      display: block;
    }
  }
  .sm\\:flex {
    @media (width >= 40rem) {
      display: flex;
    }
  }
  .sm\\:table-cell {
    @media (width >= 40rem) {
      display: table-cell;
    }
  }
  .sm\\:w-\\[52px\\] {
    @media (width >= 40rem) {
      width: 52px;
    }
  }
  .sm\\:w-\\[80px\\] {
    @media (width >= 40rem) {
      width: 80px;
    }
  }
  .sm\\:w-auto {
    @media (width >= 40rem) {
      width: auto;
    }
  }
  .sm\\:max-w-\\[300px\\] {
    @media (width >= 40rem) {
      max-width: 300px;
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-3 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-4 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-5 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:items-center {
    @media (width >= 40rem) {
      align-items: center;
    }
  }
  .sm\\:items-end {
    @media (width >= 40rem) {
      align-items: flex-end;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end;
    }
  }
  .sm\\:gap-3 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 3);
    }
  }
  .sm\\:p-8 {
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 8);
    }
  }
  .sm\\:p-9 {
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 9);
    }
  }
  .sm\\:px-3 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 3);
    }
  }
  .sm\\:px-5 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 5);
    }
  }
  .sm\\:px-6 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-8 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 8);
    }
  }
  .sm\\:py-5 {
    @media (width >= 40rem) {
      padding-block: calc(var(--spacing) * 5);
    }
  }
  .sm\\:py-12 {
    @media (width >= 40rem) {
      padding-block: calc(var(--spacing) * 12);
    }
  }
  .sm\\:pr-3 {
    @media (width >= 40rem) {
      padding-right: calc(var(--spacing) * 3);
    }
  }
  .sm\\:pb-20 {
    @media (width >= 40rem) {
      padding-bottom: calc(var(--spacing) * 20);
    }
  }
  .sm\\:pl-8 {
    @media (width >= 40rem) {
      padding-left: calc(var(--spacing) * 8);
    }
  }
  .sm\\:text-2xl {
    @media (width >= 40rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  .sm\\:text-3xl {
    @media (width >= 40rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .sm\\:text-5xl {
    @media (width >= 40rem) {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
  }
  .sm\\:text-lg {
    @media (width >= 40rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
  .sm\\:text-\\[11px\\] {
    @media (width >= 40rem) {
      font-size: 11px;
    }
  }
  .md\\:mb-16 {
    @media (width >= 48rem) {
      margin-bottom: calc(var(--spacing) * 16);
    }
  }
  .md\\:block {
    @media (width >= 48rem) {
      display: block;
    }
  }
  .md\\:flex {
    @media (width >= 48rem) {
      display: flex;
    }
  }
  .md\\:hidden {
    @media (width >= 48rem) {
      display: none;
    }
  }
  .md\\:w-auto {
    @media (width >= 48rem) {
      width: auto;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-4 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-\\[2\\.2fr_2\\.6fr_auto\\] {
    @media (width >= 48rem) {
      grid-template-columns: 2.2fr 2.6fr auto;
    }
  }
  .md\\:grid-cols-\\[2\\.6fr_auto\\] {
    @media (width >= 48rem) {
      grid-template-columns: 2.6fr auto;
    }
  }
  .md\\:gap-4 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 4);
    }
  }
  .md\\:gap-5 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 5);
    }
  }
  .md\\:p-5 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 5);
    }
  }
  .md\\:p-6 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 6);
    }
  }
  .md\\:p-7 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 7);
    }
  }
  .md\\:p-8 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 8);
    }
  }
  .md\\:p-9 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 9);
    }
  }
  .md\\:px-4 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 4);
    }
  }
  .md\\:py-6 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 6);
    }
  }
  .md\\:py-12 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 12);
    }
  }
  .md\\:py-16 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 16);
    }
  }
  .md\\:py-24 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 24);
    }
  }
  .md\\:py-28 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 28);
    }
  }
  .md\\:pt-16 {
    @media (width >= 48rem) {
      padding-top: calc(var(--spacing) * 16);
    }
  }
  .md\\:text-3xl {
    @media (width >= 48rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .md\\:text-4xl {
    @media (width >= 48rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .md\\:text-5xl {
    @media (width >= 48rem) {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
  }
  .md\\:text-6xl {
    @media (width >= 48rem) {
      font-size: var(--text-6xl);
      line-height: var(--tw-leading, var(--text-6xl--line-height));
    }
  }
  .md\\:text-xl {
    @media (width >= 48rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .lg\\:col-span-1 {
    @media (width >= 64rem) {
      grid-column: span 1 / span 1;
    }
  }
  .lg\\:col-span-2 {
    @media (width >= 64rem) {
      grid-column: span 2 / span 2;
    }
  }
  .lg\\:col-span-3 {
    @media (width >= 64rem) {
      grid-column: span 3 / span 3;
    }
  }
  .lg\\:flex {
    @media (width >= 64rem) {
      display: flex;
    }
  }
  .lg\\:hidden {
    @media (width >= 64rem) {
      display: none;
    }
  }
  .lg\\:w-1\\/2 {
    @media (width >= 64rem) {
      width: calc(1 / 2 * 100%);
    }
  }
  .lg\\:w-\\[45\\%\\] {
    @media (width >= 64rem) {
      width: 45%;
    }
  }
  .lg\\:flex-1 {
    @media (width >= 64rem) {
      flex: 1 1;
    }
  }
  .lg\\:grid-cols-1 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-4 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-5 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-6 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-\\[1\\.6fr_1fr\\] {
    @media (width >= 64rem) {
      grid-template-columns: 1.6fr 1fr;
    }
  }
  .lg\\:flex-row {
    @media (width >= 64rem) {
      flex-direction: row;
    }
  }
  .lg\\:gap-8 {
    @media (width >= 64rem) {
      gap: calc(var(--spacing) * 8);
    }
  }
  .lg\\:space-y-8 {
    @media (width >= 64rem) {
      :where(& > :not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
      }
    }
  }
  .lg\\:py-32 {
    @media (width >= 64rem) {
      padding-block: calc(var(--spacing) * 32);
    }
  }
  .lg\\:pt-20 {
    @media (width >= 64rem) {
      padding-top: calc(var(--spacing) * 20);
    }
  }
  .lg\\:text-4xl {
    @media (width >= 64rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .lg\\:text-7xl {
    @media (width >= 64rem) {
      font-size: var(--text-7xl);
      line-height: var(--tw-leading, var(--text-7xl--line-height));
    }
  }
  .xl\\:col-span-2 {
    @media (width >= 80rem) {
      grid-column: span 2 / span 2;
    }
  }
  .xl\\:grid-cols-3 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-4 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-5 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .dark\\:border-amber-500\\/25 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-amber-500) 25%, transparent);
      }
    }
  }
  .dark\\:border-amber-500\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-amber-500) 30%, transparent);
      }
    }
  }
  .dark\\:border-amber-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-amber-800);
    }
  }
  .dark\\:border-amber-900 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-amber-900);
    }
  }
  .dark\\:border-blue-500\\/25 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-blue-500) 25%, transparent);
      }
    }
  }
  .dark\\:border-blue-800\\/50 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(42.4% 0.199 265.638) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-blue-800) 50%, transparent);
      }
    }
  }
  .dark\\:border-blue-900\\/50 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(37.9% 0.146 265.522) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-blue-900) 50%, transparent);
      }
    }
  }
  .dark\\:border-cyan-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-cyan-800);
    }
  }
  .dark\\:border-cyan-900 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-cyan-900);
    }
  }
  .dark\\:border-green-500\\/25 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-green-500) 25%, transparent);
      }
    }
  }
  .dark\\:border-green-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-green-800);
    }
  }
  .dark\\:border-green-900 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-green-900);
    }
  }
  .dark\\:border-orange-900 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-orange-900);
    }
  }
  .dark\\:border-orange-900\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-orange-900) 30%, transparent);
      }
    }
  }
  .dark\\:border-orange-900\\/50 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-orange-900) 50%, transparent);
      }
    }
  }
  .dark\\:border-purple-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-purple-800);
    }
  }
  .dark\\:border-purple-900 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-purple-900);
    }
  }
  .dark\\:border-red-500\\/25 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-red-500) 25%, transparent);
      }
    }
  }
  .dark\\:border-red-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-red-800);
    }
  }
  .dark\\:border-slate-700 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: var(--color-slate-700);
    }
  }
  .dark\\:border-violet-500\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      border-color: color-mix(in srgb, oklch(60.6% 0.25 292.717) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-violet-500) 30%, transparent);
      }
    }
  }
  .dark\\:bg-amber-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-amber-500) 10%, transparent);
      }
    }
  }
  .dark\\:bg-amber-500\\/15 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 15%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-amber-500) 15%, transparent);
      }
    }
  }
  .dark\\:bg-amber-900\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(41.4% 0.112 45.904) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-amber-900) 10%, transparent);
      }
    }
  }
  .dark\\:bg-amber-950\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(27.9% 0.077 45.635) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-amber-950) 20%, transparent);
      }
    }
  }
  .dark\\:bg-amber-950\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(27.9% 0.077 45.635) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-amber-950) 30%, transparent);
      }
    }
  }
  .dark\\:bg-blue-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-blue-500) 10%, transparent);
      }
    }
  }
  .dark\\:bg-blue-900\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(37.9% 0.146 265.522) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-blue-900) 10%, transparent);
      }
    }
  }
  .dark\\:bg-blue-900\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(37.9% 0.146 265.522) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-blue-900) 30%, transparent);
      }
    }
  }
  .dark\\:bg-card {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: var(--color-card);
    }
  }
  .dark\\:bg-cyan-950\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(30.2% 0.056 229.695) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-cyan-950) 20%, transparent);
      }
    }
  }
  .dark\\:bg-cyan-950\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(30.2% 0.056 229.695) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-cyan-950) 30%, transparent);
      }
    }
  }
  .dark\\:bg-emerald-900\\/5 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(37.8% 0.077 168.94) 5%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-emerald-900) 5%, transparent);
      }
    }
  }
  .dark\\:bg-green-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-green-500) 10%, transparent);
      }
    }
  }
  .dark\\:bg-green-900\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(39.3% 0.095 152.535) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-green-900) 10%, transparent);
      }
    }
  }
  .dark\\:bg-green-950\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(26.6% 0.065 152.934) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-green-950) 20%, transparent);
      }
    }
  }
  .dark\\:bg-green-950\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(26.6% 0.065 152.934) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-green-950) 30%, transparent);
      }
    }
  }
  .dark\\:bg-orange-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-orange-500) 10%, transparent);
      }
    }
  }
  .dark\\:bg-orange-900\\/5 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 5%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-orange-900) 5%, transparent);
      }
    }
  }
  .dark\\:bg-orange-900\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-orange-900) 10%, transparent);
      }
    }
  }
  .dark\\:bg-orange-900\\/40 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 40%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-orange-900) 40%, transparent);
      }
    }
  }
  .dark\\:bg-orange-950\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(26.6% 0.079 36.259) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-orange-950) 20%, transparent);
      }
    }
  }
  .dark\\:bg-orange-950\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(26.6% 0.079 36.259) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-orange-950) 30%, transparent);
      }
    }
  }
  .dark\\:bg-purple-950\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(29.1% 0.149 302.717) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-purple-950) 20%, transparent);
      }
    }
  }
  .dark\\:bg-purple-950\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(29.1% 0.149 302.717) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-purple-950) 30%, transparent);
      }
    }
  }
  .dark\\:bg-red-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-red-500) 10%, transparent);
      }
    }
  }
  .dark\\:bg-red-500\\/15 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 15%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-red-500) 15%, transparent);
      }
    }
  }
  .dark\\:bg-red-900\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(39.6% 0.141 25.723) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-red-900) 20%, transparent);
      }
    }
  }
  .dark\\:bg-slate-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: var(--color-slate-800);
    }
  }
  .dark\\:bg-slate-800\\/20 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 20%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-slate-800) 20%, transparent);
      }
    }
  }
  .dark\\:bg-slate-900\\/30 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-slate-900) 30%, transparent);
      }
    }
  }
  .dark\\:bg-violet-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(60.6% 0.25 292.717) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-violet-500) 10%, transparent);
      }
    }
  }
  .dark\\:bg-white\\/5 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, #fff 5%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
      }
    }
  }
  .dark\\:bg-white\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, #fff 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
      }
    }
  }
  .dark\\:bg-yellow-500\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-yellow-500) 10%, transparent);
      }
    }
  }
  .dark\\:from-orange-900\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      --tw-gradient-from: color-mix(in srgb, oklch(40.8% 0.123 38.172) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-gradient-from: color-mix(in oklab, var(--color-orange-900) 10%, transparent);
      }
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
  }
  .dark\\:to-amber-900\\/10 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      --tw-gradient-to: color-mix(in srgb, oklch(41.4% 0.112 45.904) 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-gradient-to: color-mix(in oklab, var(--color-amber-900) 10%, transparent);
      }
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
  }
  .dark\\:text-amber-100 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-amber-100);
    }
  }
  .dark\\:text-amber-300 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-amber-300);
    }
  }
  .dark\\:text-amber-300\\/90 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: color-mix(in srgb, oklch(87.9% 0.169 91.605) 90%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-amber-300) 90%, transparent);
      }
    }
  }
  .dark\\:text-amber-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-amber-400);
    }
  }
  .dark\\:text-amber-500 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-amber-500);
    }
  }
  .dark\\:text-amber-500\\/80 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 80%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-amber-500) 80%, transparent);
      }
    }
  }
  .dark\\:text-blue-100 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-blue-100);
    }
  }
  .dark\\:text-blue-200 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-blue-200);
    }
  }
  .dark\\:text-blue-300\\/80 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: color-mix(in srgb, oklch(80.9% 0.105 251.813) 80%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-blue-300) 80%, transparent);
      }
    }
  }
  .dark\\:text-blue-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-blue-400);
    }
  }
  .dark\\:text-blue-400\\/60 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: color-mix(in srgb, oklch(70.7% 0.165 254.624) 60%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-blue-400) 60%, transparent);
      }
    }
  }
  .dark\\:text-cyan-300 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-cyan-300);
    }
  }
  .dark\\:text-cyan-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-cyan-400);
    }
  }
  .dark\\:text-emerald-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-emerald-400);
    }
  }
  .dark\\:text-green-300 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-green-300);
    }
  }
  .dark\\:text-green-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-green-400);
    }
  }
  .dark\\:text-green-400\\/50 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: color-mix(in srgb, oklch(79.2% 0.209 151.711) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-green-400) 50%, transparent);
      }
    }
  }
  .dark\\:text-green-500 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-green-500);
    }
  }
  .dark\\:text-indigo-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-indigo-400);
    }
  }
  .dark\\:text-orange-100 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-orange-100);
    }
  }
  .dark\\:text-orange-200 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-orange-200);
    }
  }
  .dark\\:text-orange-300 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-orange-300);
    }
  }
  .dark\\:text-orange-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-orange-400);
    }
  }
  .dark\\:text-purple-300 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-purple-300);
    }
  }
  .dark\\:text-purple-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-purple-400);
    }
  }
  .dark\\:text-red-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-red-400);
    }
  }
  .dark\\:text-slate-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-slate-400);
    }
  }
  .dark\\:text-violet-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      color: var(--color-violet-400);
    }
  }
  .dark\\:ring-gray-800 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      --tw-ring-color: var(--color-gray-800);
    }
  }
  .dark\\:group-hover\\:text-indigo-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      &:is(:where(.group):hover *) {
        @media (hover: hover) {
          color: var(--color-indigo-400);
        }
      }
    }
  }
  .dark\\:hover\\:bg-white\\/5 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      &:hover {
        @media (hover: hover) {
          background-color: color-mix(in srgb, #fff 5%, transparent);
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
          }
        }
      }
    }
  }
  .dark\\:hover\\:text-green-300 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-green-300);
        }
      }
    }
  }
  .dark\\:hover\\:text-red-400 {
    &:where([data-mode="dark"], [data-mode="dark"] *) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-red-400);
        }
      }
    }
  }
  .\\[\\&_\\.ant-table\\]\\:rounded-none {
    & .ant-table {
      border-radius: 0;
    }
  }
  .\\[\\&_\\.ant-table-container\\]\\:border-none {
    & .ant-table-container {
      --tw-border-style: none;
      border-style: none;
    }
  }
  .\\[\\&\\>\\.ant-card-body\\]\\:h-full {
    &>.ant-card-body {
      height: 100%;
    }
  }
  .\\[\\&\\>\\.ant-card-body\\]\\:p-4 {
    &>.ant-card-body {
      padding: calc(var(--spacing) * 4);
    }
  }
}
:root[data-color="neutral"] {
  --bg-gradient: linear-gradient(180deg, #F8FBFF 0%, #F2F7FC 100%);
  --background: #F8FBFF;
  --foreground: #1F2937;
  --card: #FFFFFF;
  --card-foreground: #1F2937;
  --popover: #FFFFFF;
  --popover-foreground: #1F2937;
  --primary: #7FAFD8;
  --primary-foreground: #FFFFFF;
  --primary-hover: #6A9CC8;
  --secondary: #F0F6FC;
  --secondary-foreground: #334155;
  --accent: #EEF6FF;
  --accent-foreground: #1F3A5F;
  --muted: #F1F5F9;
  --muted-foreground: #64748B;
  --border: #D9E8F5;
  --input: #D8E6F3;
  --ring: #7FAFD8;
  --chart-1: #7FAFD8;
  --chart-2: #AFCBE8;
  --chart-3: #F59E0B;
  --chart-4: #10B981;
  --chart-5: #E2EDF7;
  --sidebar-gradient: linear-gradient(180deg, #F6FAFF 0%, #EAF3FC 100%);
  --sidebar: #F0F6FC;
  --sidebar-foreground: #1F3A5F;
  --sidebar-primary: linear-gradient(135deg, #AFCBE8 0%, #9DBFDF 100%);
  --sidebar-primary-foreground: #1F3A5F;
  --sidebar-accent: #E4EFF8;
  --sidebar-accent-foreground: #1F3A5F;
  --sidebar-border: #D9E8F5;
  --sidebar-ring: #7FAFD8;
  --success: #ECFDF5;
  --success-foreground: #10B981;
  --warning: #FFFBEB;
  --warning-foreground: #F59E0B;
  --destructive: #EF4444;
  --destructive-foreground: #FFFFFF;
  --info: #EEF6FF;
  --info-foreground: #7FAFD8;
  --live: #EF4444;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #713F12;
}
:root[data-color="premium"] {
  --bg-gradient: linear-gradient(180deg, #F7F2ED 0%, #F4EEE9 100%);
  --background: #F4EEE9;
  --foreground: #1A1714;
  --card: #FFFFFF;
  --card-foreground: #1A1714;
  --popover: #FFFFFF;
  --popover-foreground: #1A1714;
  --primary: #F05409;
  --primary-foreground: #FFFFFF;
  --primary-hover: #E8480A;
  --secondary: #EDE6E0;
  --secondary-foreground: #3A332E;
  --accent: #FCE9DE;
  --accent-foreground: #C2410C;
  --muted: #EDE6E0;
  --muted-foreground: #6B645E;
  --border: #E4DCD3;
  --input: #E4DCD3;
  --ring: #F05409;
  --brand: #F05409;
  --brand-foreground: #FFFFFF;
  --accent-gradient: linear-gradient(135deg, #F05409, #FF7A33);
  --chart-1: #F05409;
  --chart-2: #FF7A33;
  --chart-3: #FFB088;
  --chart-4: #16A34A;
  --chart-5: #EAB308;
  --sidebar-gradient: linear-gradient(180deg, #FBF8F5 0%, #FBF8F5 100%);
  --sidebar: #FBF8F5;
  --sidebar-foreground: #3A332E;
  --sidebar-primary: linear-gradient(135deg, #F05409 0%, #FF7A33 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #FCE9DE;
  --sidebar-accent-foreground: #C2410C;
  --sidebar-border: #E4DCD3;
  --sidebar-ring: #F05409;
  --success: #ECFDF5;
  --success-foreground: #16A34A;
  --warning: #FFFBEB;
  --warning-foreground: #D97706;
  --destructive: #DC2626;
  --destructive-foreground: #FFFFFF;
  --info: #FCE9DE;
  --info-foreground: #C2410C;
  --live: #EF4444;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #713F12;
}
:root[data-color="blue"] {
  --bg-gradient: linear-gradient(180deg, #F8FBFF 0%, #F2F7FC 100%);
  --background: #F8FBFF;
  --foreground: #1F2937;
  --card: #FFFFFF;
  --card-foreground: #1F2937;
  --popover: #FFFFFF;
  --popover-foreground: #1F2937;
  --primary: #7FAFD8;
  --primary-foreground: #FFFFFF;
  --primary-hover: #6A9CC8;
  --secondary: #F0F6FC;
  --secondary-foreground: #334155;
  --accent: #EEF6FF;
  --accent-foreground: #1F3A5F;
  --muted: #F1F5F9;
  --muted-foreground: #64748B;
  --border: #D9E8F5;
  --input: #D8E6F3;
  --ring: #7FAFD8;
  --chart-1: #7FAFD8;
  --chart-2: #AFCBE8;
  --chart-3: #F59E0B;
  --chart-4: #10B981;
  --chart-5: #E2EDF7;
  --sidebar-gradient: linear-gradient(180deg, #F6FAFF 0%, #EAF3FC 100%);
  --sidebar: #F0F6FC;
  --sidebar-foreground: #1F3A5F;
  --sidebar-primary: linear-gradient(135deg, #AFCBE8 0%, #9DBFDF 100%);
  --sidebar-primary-foreground: #1F3A5F;
  --sidebar-accent: #E4EFF8;
  --sidebar-accent-foreground: #1F3A5F;
  --sidebar-border: #D9E8F5;
  --sidebar-ring: #7FAFD8;
  --success: #ECFDF5;
  --success-foreground: #10B981;
  --warning: #FFFBEB;
  --warning-foreground: #F59E0B;
  --destructive: #EF4444;
  --destructive-foreground: #FFFFFF;
  --info: #EDE9FE;
  --info-foreground: #7C3AED;
  --live: #EF4444;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #713F12;
}
:root[data-color="emerald"] {
  --bg-gradient: linear-gradient(180deg, #F6FBF9 0%, #EFF7F3 100%);
  --background: #F6FBF9;
  --foreground: #14201B;
  --card: #FFFFFF;
  --card-foreground: #14201B;
  --popover: #FFFFFF;
  --popover-foreground: #14201B;
  --primary: #059669;
  --primary-foreground: #FFFFFF;
  --primary-hover: #047857;
  --secondary: #EAF6F1;
  --secondary-foreground: #334E45;
  --accent: #ECFDF5;
  --accent-foreground: #065F46;
  --muted: #F0F7F4;
  --muted-foreground: #5B6B64;
  --border: #D6EDE3;
  --input: #CFE8DD;
  --ring: #059669;
  --chart-1: #059669;
  --chart-2: #34D399;
  --chart-3: #F59E0B;
  --chart-4: #3B82F6;
  --chart-5: #D1FAE5;
  --sidebar-gradient: linear-gradient(180deg, #F2F9F6 0%, #E7F4EE 100%);
  --sidebar: #F2F9F6;
  --sidebar-foreground: #14483A;
  --sidebar-primary: linear-gradient(135deg, #059669 0%, #10B981 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #DCF3EA;
  --sidebar-accent-foreground: #065F46;
  --sidebar-border: #D6EDE3;
  --sidebar-ring: #059669;
  --success: #ECFDF5;
  --success-foreground: #059669;
  --warning: #FFFBEB;
  --warning-foreground: #D97706;
  --destructive: #DC2626;
  --destructive-foreground: #FFFFFF;
  --info: #ECFDF5;
  --info-foreground: #059669;
  --live: #EF4444;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #713F12;
}
:root[data-color="violet"] {
  --bg-gradient: linear-gradient(180deg, #FAF8FF 0%, #F4F0FC 100%);
  --background: #FAF8FF;
  --foreground: #221B2E;
  --card: #FFFFFF;
  --card-foreground: #221B2E;
  --popover: #FFFFFF;
  --popover-foreground: #221B2E;
  --primary: #7C3AED;
  --primary-foreground: #FFFFFF;
  --primary-hover: #6D28D9;
  --secondary: #F1EBFB;
  --secondary-foreground: #4C3A63;
  --accent: #F3EEFF;
  --accent-foreground: #5B21B6;
  --muted: #F4F0FA;
  --muted-foreground: #6B6577;
  --border: #E7DEF7;
  --input: #E2D8F4;
  --ring: #7C3AED;
  --chart-1: #7C3AED;
  --chart-2: #A78BFA;
  --chart-3: #F59E0B;
  --chart-4: #10B981;
  --chart-5: #EDE9FE;
  --sidebar-gradient: linear-gradient(180deg, #F6F2FE 0%, #EEE7FB 100%);
  --sidebar: #F6F2FE;
  --sidebar-foreground: #4C2D82;
  --sidebar-primary: linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #E9DEFB;
  --sidebar-accent-foreground: #5B21B6;
  --sidebar-border: #E7DEF7;
  --sidebar-ring: #7C3AED;
  --success: #ECFDF5;
  --success-foreground: #059669;
  --warning: #FFFBEB;
  --warning-foreground: #D97706;
  --destructive: #DC2626;
  --destructive-foreground: #FFFFFF;
  --info: #F3EEFF;
  --info-foreground: #7C3AED;
  --live: #EF4444;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #713F12;
}
:root[data-color="dark"] {
  color-scheme: dark;
  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);
  --background: #0A0A0A;
  --foreground: #F5F3F1;
  --card: #161513;
  --card-foreground: #F5F3F1;
  --popover: #161513;
  --popover-foreground: #F5F3F1;
  --primary: #F05409;
  --primary-foreground: #FFFFFF;
  --primary-hover: #FF6A2A;
  --secondary: #1F1C18;
  --secondary-foreground: #E7E3DE;
  --accent: #2A1D14;
  --accent-foreground: #FF8A3D;
  --muted: #1A1714;
  --muted-foreground: #A8A29B;
  --border: rgba(255, 255, 255, 0.08);
  --input: rgba(255, 255, 255, 0.12);
  --ring: #F05409;
  --brand: #F05409;
  --brand-foreground: #FFFFFF;
  --accent-gradient: linear-gradient(135deg, #F05409, #FF7A33);
  --chart-1: #F05409;
  --chart-2: #FF7A33;
  --chart-3: #FFB088;
  --chart-4: #34D399;
  --chart-5: #FBBF24;
  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);
  --sidebar: #100F0D;
  --sidebar-foreground: #CFCAC4;
  --sidebar-primary: linear-gradient(135deg, #F05409 0%, #FF7A33 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #2A1D14;
  --sidebar-accent-foreground: #FF8A3D;
  --sidebar-border: rgba(255, 255, 255, 0.08);
  --sidebar-ring: #F05409;
  --success: #0B2E22;
  --success-foreground: #34D399;
  --warning: #2E2205;
  --warning-foreground: #FBBF24;
  --destructive: #F4593C;
  --destructive-foreground: #FFFFFF;
  --info: #2A1D14;
  --info-foreground: #FF8A3D;
  --live: #F4593C;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #FEF9C3;
}
:root[data-color="neutral-dark"],
:root[data-color="blue-dark"] {
  color-scheme: dark;
  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);
  --background: #0A0A0A;
  --foreground: #F5F3F1;
  --card: #161513;
  --card-foreground: #F5F3F1;
  --popover: #161513;
  --popover-foreground: #F5F3F1;
  --primary: #7FAFD8;
  --primary-foreground: #FFFFFF;
  --primary-hover: #6A9CC8;
  --secondary: #1F1C18;
  --secondary-foreground: #E7E3DE;
  --accent: #1C2A38;
  --accent-foreground: #AFCBE8;
  --muted: #1A1714;
  --muted-foreground: #A8A29B;
  --border: rgba(255, 255, 255, 0.08);
  --input: rgba(255, 255, 255, 0.12);
  --ring: #7FAFD8;
  --brand: #7FAFD8;
  --brand-foreground: #FFFFFF;
  --accent-gradient: linear-gradient(135deg, #7FAFD8, #A9CBE8);
  --chart-1: #7FAFD8;
  --chart-2: #AFCBE8;
  --chart-3: #F59E0B;
  --chart-4: #34D399;
  --chart-5: #4B5563;
  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);
  --sidebar: #100F0D;
  --sidebar-foreground: #CFCAC4;
  --sidebar-primary: linear-gradient(135deg, #7FAFD8 0%, #6A9CC8 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #1C2A38;
  --sidebar-accent-foreground: #AFCBE8;
  --sidebar-border: rgba(255, 255, 255, 0.08);
  --sidebar-ring: #7FAFD8;
  --success: #0B2E22;
  --success-foreground: #34D399;
  --warning: #2E2205;
  --warning-foreground: #FBBF24;
  --destructive: #F4593C;
  --destructive-foreground: #FFFFFF;
  --info: #1C2A38;
  --info-foreground: #AFCBE8;
  --live: #F4593C;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #FEF9C3;
}
:root[data-color="emerald-dark"] {
  color-scheme: dark;
  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);
  --background: #0A0A0A;
  --foreground: #F5F3F1;
  --card: #161513;
  --card-foreground: #F5F3F1;
  --popover: #161513;
  --popover-foreground: #F5F3F1;
  --primary: #059669;
  --primary-foreground: #FFFFFF;
  --primary-hover: #047857;
  --secondary: #1F1C18;
  --secondary-foreground: #E7E3DE;
  --accent: #11291F;
  --accent-foreground: #34D399;
  --muted: #1A1714;
  --muted-foreground: #A8A29B;
  --border: rgba(255, 255, 255, 0.08);
  --input: rgba(255, 255, 255, 0.12);
  --ring: #10B981;
  --brand: #059669;
  --brand-foreground: #FFFFFF;
  --accent-gradient: linear-gradient(135deg, #059669, #10B981);
  --chart-1: #10B981;
  --chart-2: #34D399;
  --chart-3: #F59E0B;
  --chart-4: #60A5FA;
  --chart-5: #374151;
  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);
  --sidebar: #100F0D;
  --sidebar-foreground: #CFCAC4;
  --sidebar-primary: linear-gradient(135deg, #059669 0%, #10B981 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #11291F;
  --sidebar-accent-foreground: #34D399;
  --sidebar-border: rgba(255, 255, 255, 0.08);
  --sidebar-ring: #10B981;
  --success: #0B2E22;
  --success-foreground: #34D399;
  --warning: #2E2205;
  --warning-foreground: #FBBF24;
  --destructive: #F4593C;
  --destructive-foreground: #FFFFFF;
  --info: #11291F;
  --info-foreground: #34D399;
  --live: #F4593C;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #FEF9C3;
}
:root[data-color="violet-dark"] {
  color-scheme: dark;
  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);
  --background: #0A0A0A;
  --foreground: #F5F3F1;
  --card: #161513;
  --card-foreground: #F5F3F1;
  --popover: #161513;
  --popover-foreground: #F5F3F1;
  --primary: #7C3AED;
  --primary-foreground: #FFFFFF;
  --primary-hover: #6D28D9;
  --secondary: #1F1C18;
  --secondary-foreground: #E7E3DE;
  --accent: #241B33;
  --accent-foreground: #A78BFA;
  --muted: #1A1714;
  --muted-foreground: #A8A29B;
  --border: rgba(255, 255, 255, 0.08);
  --input: rgba(255, 255, 255, 0.12);
  --ring: #8B5CF6;
  --brand: #7C3AED;
  --brand-foreground: #FFFFFF;
  --accent-gradient: linear-gradient(135deg, #7C3AED, #8B5CF6);
  --chart-1: #8B5CF6;
  --chart-2: #A78BFA;
  --chart-3: #F59E0B;
  --chart-4: #34D399;
  --chart-5: #374151;
  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);
  --sidebar: #100F0D;
  --sidebar-foreground: #CFCAC4;
  --sidebar-primary: linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%);
  --sidebar-primary-foreground: #FFFFFF;
  --sidebar-accent: #241B33;
  --sidebar-accent-foreground: #A78BFA;
  --sidebar-border: rgba(255, 255, 255, 0.08);
  --sidebar-ring: #8B5CF6;
  --success: #0B2E22;
  --success-foreground: #34D399;
  --warning: #2E2205;
  --warning-foreground: #FBBF24;
  --destructive: #F4593C;
  --destructive-foreground: #FFFFFF;
  --info: #241B33;
  --info-foreground: #A78BFA;
  --live: #F4593C;
  --live-foreground: #FFFFFF;
  --gold: #EAB308;
  --gold-foreground: #FEF9C3;
}
html {
  scrollbar-gutter: stable;
}
body {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--background);
  background-image: var(--bg-gradient);
  min-height: 100vh;
  color: var(--foreground);
  cursor: default;
  font-size: 14px;
  line-height: 1.5;
  transition: background-color 200ms ease, color 150ms ease;
}
.bg-accent-grad {
  background-image: var(--accent-gradient, linear-gradient(135deg, #F05409, #FF7A33));
}
:focus:not(:focus-visible) {
  outline: none;
}
a:focus-visible,
input:not([class*="ant-"]):focus-visible,
textarea:not([class*="ant-"]):focus-visible,
select:not([class*="ant-"]):focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
}
div, span, p, td, th, h1, h2, h3, h4, h5, h6, label {
  cursor: default;
}
input, textarea, [contenteditable="true"], .selectable-text {
  cursor: text;
}
a, button, [role="button"], .cursor-pointer {
  cursor: pointer;
}
.sidebar-scroll::-webkit-scrollbar {
  width: 4px;
}
.sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-scroll::-webkit-scrollbar-thumb {
  background: var(--sidebar-border);
  border-radius: 4px;
}
.sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--muted-foreground);
}
@keyframes page-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.page-enter {
  animation: page-in 140ms ease-out forwards;
}
@view-transition {
  navigation: auto;
}
.app-sidebar {
  view-transition-name: app-sidebar;
}
.app-header {
  view-transition-name: app-header;
}
::view-transition-old(app-sidebar),
::view-transition-new(app-sidebar),
::view-transition-old(app-header),
::view-transition-new(app-header) {
  animation: none;
}
::view-transition-old(root),
::view-transition-new(root) {
  animation-duration: 100ms;
  animation-timing-function: ease;
}
@keyframes float1 {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(20px, -15px);
  }
  50% {
    transform: translate(0, -30px);
  }
  75% {
    transform: translate(-20px, -15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes float2 {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(-18px, -20px);
  }
  50% {
    transform: translate(0, -35px);
  }
  75% {
    transform: translate(18px, -20px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes float3 {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(22px, 12px);
  }
  50% {
    transform: translate(0, 28px);
  }
  75% {
    transform: translate(-22px, 12px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.dark-glass-drawer .ant-drawer-content {
  background: transparent !important;
}
.dark-checkbox .ant-checkbox-inner {
  background-color: var(--card) !important;
  border-color: var(--border) !important;
}
.dark-checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
.dark-segmented .ant-segmented-item {
  color: var(--muted-foreground) !important;
}
.dark-segmented .ant-segmented-item-selected {
  background-color: var(--accent) !important;
  color: var(--primary) !important;
}
.live-pulse {
  animation: pulse-red-lite 2s infinite;
}
@keyframes pulse-red-lite {
  0% {
    transform: scale(0.95);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.8;
  }
}
.rbc-calendar {
  color: var(--foreground);
}
.rbc-toolbar button {
  color: var(--foreground) !important;
  background-color: transparent !important;
  border-color: var(--border) !important;
  border-radius: 8px !important;
  padding: 4px 14px !important;
  transition: background-color 120ms ease, color 120ms ease !important;
}
.rbc-toolbar button:hover {
  background-color: var(--muted) !important;
  color: var(--foreground) !important;
  border-color: var(--border) !important;
}
.rbc-toolbar button:focus {
  outline: none !important;
  background-color: transparent !important;
  color: var(--foreground) !important;
  box-shadow: none !important;
}
.rbc-toolbar button:focus:hover {
  background-color: var(--muted) !important;
}
.rbc-toolbar button.rbc-active,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button.rbc-active:focus {
  background-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
  border-color: var(--primary) !important;
  box-shadow: none !important;
}
.rbc-header {
  background-color: var(--muted);
  color: var(--foreground);
  border-color: var(--border);
}
.rbc-header + .rbc-header {
  border-left-color: var(--border);
}
.rbc-off-range-bg {
  background-color: #F8FAFC;
}
.rbc-today {
  background-color: #EFF6FF;
}
:root[data-mode="dark"] .rbc-off-range-bg {
  background-color: var(--background);
}
:root[data-mode="dark"] .rbc-today {
  background-color: rgba(255, 255, 255, 0.025);
}
:root[data-mode="dark"] .rbc-day-slot .rbc-time-slot {
  border-top-color: rgba(255, 255, 255, 0.04);
}
.rbc-month-view,
.rbc-time-view,
.rbc-agenda-view {
  background-color: var(--card);
  border-color: var(--border);
}
.rbc-month-row + .rbc-month-row {
  border-top-color: var(--border);
}
.rbc-day-bg + .rbc-day-bg {
  border-left-color: var(--border);
}
.rbc-time-content {
  border-top-color: var(--border);
}
.rbc-time-content > * + * > * {
  border-left-color: var(--border);
}
.rbc-timeslot-group {
  border-bottom-color: var(--border);
}
.rbc-time-slot {
  color: var(--muted-foreground);
}
.rbc-time-header-content {
  border-left-color: var(--border);
}
.rbc-time-header.rbc-overflowing {
  border-right-color: var(--border);
}
.rbc-time-gutter .rbc-timeslot-group {
  color: var(--muted-foreground);
}
.rbc-day-slot .rbc-time-slot {
  border-top-color: rgba(0, 0, 0, 0.05);
}
.rbc-event {
  background-color: var(--primary);
  color: var(--primary-foreground);
  border-color: transparent;
}
.rbc-event.rbc-selected {
  background-color: var(--primary-hover);
}
.rbc-show-more {
  color: var(--primary);
}
.rbc-date-cell {
  color: var(--foreground);
}
.rbc-off-range {
  color: var(--muted-foreground);
}
.rbc-agenda-view table.rbc-agenda-table {
  border-color: var(--border);
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  border-bottom-color: var(--border);
  color: var(--foreground);
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  border-top-color: var(--border);
  color: var(--foreground);
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-color: var(--border);
}
.rbc-current-time-indicator {
  background-color: var(--destructive);
}
.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-input-search-button) {
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn.ant-btn-icon-only:not(.ant-btn-circle) {
  border-radius: 8px;
}
.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-input-search-button):not(:disabled):hover {
  background: var(--muted);
  border-color: transparent;
  color: var(--foreground);
}
.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-input-search-button):not(:disabled):active {
  background: var(--muted);
  @supports (color: color-mix(in lab, red, red)) {
    background: color-mix(in srgb, var(--muted) 75%, var(--foreground) 10%);
  }
}
.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):disabled {
  background: transparent;
  border-color: transparent;
}
@media (max-width: 767.98px) {
  .sidebar-mobile {
    width: 270px !important;
    transform: translateX(-100%);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15) !important;
  }
  .sidebar-mobile.sidebar-mobile-open {
    transform: translateX(0);
  }
}
@media (max-width: 767.98px) {
  .page-title {
    font-size: 16px;
  }
  .page-subtitle {
    font-size: 12px;
  }
  .page-content {
    gap: 14px;
  }
  .filter-card {
    padding: 12px;
    border-radius: 12px;
  }
  .content-card {
    border-radius: 12px;
  }
  .dash-card {
    border-radius: 12px;
  }
  .ant-table-thead > tr > th,
  .ant-table-thead > tr > td {
    padding: 8px 10px !important;
    font-size: 11px !important;
  }
  .ant-table-tbody > tr > td {
    padding: 10px 10px !important;
    font-size: 12px !important;
  }
  .ant-btn {
    height: 34px !important;
    padding-inline: 12px !important;
    font-size: 12px !important;
  }
  .ant-btn.ant-btn-sm {
    height: 26px !important;
    padding-inline: 8px !important;
  }
  .ant-form-item {
    margin-bottom: 12px !important;
  }
  .ant-modal {
    max-width: calc(100vw - 24px) !important;
    margin: 12px auto !important;
  }
  .ant-modal-body {
    padding: 16px !important;
  }
  .ant-drawer-content-wrapper {
    max-width: 100vw !important;
  }
  .ant-drawer-body {
    padding: 16px !important;
  }
  .ant-card-body {
    padding: 14px !important;
  }
  .ant-card-head {
    padding: 0 14px !important;
  }
  .ant-tabs-nav {
    flex-wrap: nowrap !important;
  }
  .ant-tabs-tab {
    font-size: 12px !important;
    padding: 8px 0 !important;
  }
  .ant-descriptions-row {
    display: flex !important;
    flex-direction: column !important;
  }
  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    display: block !important;
    width: 100% !important;
    padding: 6px 12px !important;
  }
  .ant-col-6,
  .ant-col-8,
  .ant-col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .ant-segmented {
    flex-wrap: wrap !important;
  }
  .ant-steps-item-title {
    font-size: 12px !important;
  }
}
@media (min-width: 768px) and (max-width: 1023.98px) {
  .page-title {
    font-size: 17px;
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/index.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;ICQA,gFAAiF;IDH/E;8BAE0B;IAE1B,wCAAwC;IACxC,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAG1C,0CAA0C;IAC1C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,2CAA2C;IAC3C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,2CAA2C;IAC3C,6CAA6C;IAC7C,6CAA6C;IAE7C,2CAA2C;IAC3C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAE5C,6CAA6C;IAG7C,6CAA6C;IAE7C,6CAA6C;IAC7C,6CAA6C;IAkB7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAE7C,8CAA8C;IAI9C,+CAA+C;IAC/C,6CAA6C;IAC7C,+CAA+C;IAG/C,8CAA8C;IAe9C,2CAA2C;IAE3C,2CAA2C;IAC3C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAE5C,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;IAC3C,4CAA4C;IAO5C,2CAA2C;IAE3C,yCAAyC;IACzC,yCAAyC;IAIzC,yCAAyC;IACzC,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAO5C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAM9C,6CAA6C;IAE7C,8CAA8C;IAE9C,8CAA8C;IAC9C,6CAA6C;IAC7C,8CAA8C;IAC9C,6CAA6C;IAK7C,6CAA6C;IAE7C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,4CAA4C;IAC5C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAsC9C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAG7C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAE5C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,0CAA0C;IAuF1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,0BAA0B;IAI1B,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IAExB,2BAA2B;IAC3B,0BAA0B;IAE1B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAExB,qBAAqB;IACrB,qBAAqB;IAErB,wBAAwB;IAKxB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IAmBpB,6CAA6C;IAC7C,6CAA6C;IAE7C,4CAA4C;IAiB5C,2CAA2C;IAE3C,uCAAuC;IAEvC,+DAA+D;IAqC/D,cAAc;IACd,eAAe;IAEf,eAAe;IACf,gBAAgB;IAShB,sBAAsB;IAEtB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;IClf3D,qCAAsC;IACtC,qCAAsC;IAKtC,yBAA0B;IAC1B,+CAAgD;IAEhD,+BAAgC;IAGhC,+BAAgC;IAChC,qDAAsD;IAEtD,mCAAoC;IAGpC,6BAA8B;IAC9B,mDAAoD;IAEpD,2BAA4B;IAC5B,iDAAkD;IAElD,6BAA8B;IAI9B,uCAAwC;IAkBxC,kCAAmC;IACnC,qDAAsD;IACtD,+CAAgD;IAChD,qEAAsE;IACtE,6CAA8C;IAE9C,6CAA8C;ED9D/B;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IAEE,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IAEd,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB,iBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB;MAAA,uEAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;IAAnB;MAAA,uEAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;IAAnB;MAAA,uEAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;IAAnB;MAAA,uEAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;IAAnB;MAAA,uEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB;MAAA,qEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB;MAAA,qFAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8EAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB;MAAA,qFAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB;MAAA,mFAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB;MAAA,6EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kFAAmB;IAAnB;MAAA,uIAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,yIAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yDAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,4FAAmB;IAAnB,oDAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,4FAAmB;IAAnB,oDAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,oDAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,gTAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,4EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,WAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;QAAnB;UAAA,wEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;QAAnB;UAAA,wEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;QAAnB;UAAA,wEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;QAAnB;UAAA,2EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;QAAnB;UAAA,2EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,yEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;QAAnB;UAAA,4EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gFAAmB;QAAnB;UAAA,4EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;QAAnB;UAAA,8EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iFAAmB;QAAnB;UAAA,6EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;QAAnB,8LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;QAAnB,8LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;QAAnB,0LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;QAAnB,0LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,UAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,SAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uBAAmB;QAAnB,8EAAmB;QAAnB,sFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2EAAmB;MAAnB;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2EAAmB;MAAnB;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6EAAmB;MAAnB;QAAA,yEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6EAAmB;MAAnB;QAAA,yEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6EAAmB;MAAnB;QAAA,yEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6EAAmB;MAAnB;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4EAAmB;MAAnB;QAAA,2EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,4EAAmB;MAAnB;QAAA,2EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4EAAmB;MAAnB;QAAA,wEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4EAAmB;MAAnB;QAAA,2EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+EAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+EAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+EAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+EAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,4EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,4EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,4EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iFAAmB;MAAnB;QAAA,8EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,0DAAmB;MAAnB;QAAA,yEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;MAAnB;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kFAAmB;MAAnB;QAAA,iFAAmB;MAAA;MAAnB,8LAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gFAAmB;MAAnB;QAAA,8EAAmB;MAAA;MAAnB,8LAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qEAAmB;MAAnB;QAAA,mEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oEAAmB;MAAnB;QAAA,mEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sEAAmB;MAAnB;QAAA,kEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sEAAmB;MAAnB;QAAA,kEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sEAAmB;MAAnB;QAAA,mEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,8BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0DAAmB;UAAnB;YAAA,yEAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,2BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;AADJ;ACr2BjB;EACE,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EAEtB,eAAgB;EAChB,0BAA2B;EAE3B,kBAAmB;EACnB,6BAA8B;EAE9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EAEzB,oBAAqB;EACrB,+BAAgC;EAEhC,iBAAkB;EAClB,4BAA6B;EAE7B,gBAAiB;EACjB,2BAA4B;EAE5B,iBAAkB;EAClB,gBAAiB;EACjB,eAAgB;EAEhB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EAEnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,yBAA0B;EAC1B,uBAAwB;EAExB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAElC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAKD;EACE,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EAEtB,eAAgB;EAChB,0BAA2B;EAE3B,kBAAmB;EACnB,6BAA8B;EAE9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EAEzB,oBAAqB;EACrB,+BAAgC;EAEhC,iBAAkB;EAClB,4BAA6B;EAE7B,gBAAiB;EACjB,2BAA4B;EAE5B,iBAAkB;EAClB,gBAAiB;EACjB,eAAgB;EAEhB,gBAAiB;EACjB,2BAA4B;EAC5B,4DAA6D;EAE7D,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EAEnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,yBAA0B;EAC1B,uBAAwB;EAExB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAElC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAKD;EACE,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EAEtB,eAAgB;EAChB,0BAA2B;EAE3B,kBAAmB;EACnB,6BAA8B;EAE9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EAEzB,oBAAqB;EACrB,+BAAgC;EAEhC,iBAAkB;EAClB,4BAA6B;EAE7B,gBAAiB;EACjB,2BAA4B;EAE5B,iBAAkB;EAClB,gBAAiB;EACjB,eAAgB;EAEhB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EAEnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,yBAA0B;EAC1B,uBAAwB;EAExB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAElC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAKD;EACE,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EAEtB,eAAgB;EAChB,0BAA2B;EAE3B,kBAAmB;EACnB,6BAA8B;EAE9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EAEzB,oBAAqB;EACrB,+BAAgC;EAEhC,iBAAkB;EAClB,4BAA6B;EAE7B,gBAAiB;EACjB,2BAA4B;EAE5B,iBAAkB;EAClB,gBAAiB;EACjB,eAAgB;EAEhB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EAEnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,yBAA0B;EAC1B,uBAAwB;EAExB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAElC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAKD;EACE,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EAEtB,eAAgB;EAChB,0BAA2B;EAE3B,kBAAmB;EACnB,6BAA8B;EAE9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EAEzB,oBAAqB;EACrB,+BAAgC;EAEhC,iBAAkB;EAClB,4BAA6B;EAE7B,gBAAiB;EACjB,2BAA4B;EAE5B,iBAAkB;EAClB,gBAAiB;EACjB,eAAgB;EAEhB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EAEnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,yBAA0B;EAC1B,uBAAwB;EAExB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAElC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAKD;EACE,kBAAmB;EAEnB,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EAEtB,eAAgB;EAChB,0BAA2B;EAE3B,kBAAmB;EACnB,6BAA8B;EAE9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EAEzB,oBAAqB;EACrB,+BAAgC;EAEhC,iBAAkB;EAClB,4BAA6B;EAE7B,gBAAiB;EACjB,2BAA4B;EAE5B,mCAAoC;EACpC,kCAAmC;EACnC,eAAgB;EAEhB,gBAAiB;EACjB,2BAA4B;EAC5B,4DAA6D;EAE7D,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EAEnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,2CAA4C;EAC5C,uBAAwB;EAExB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAElC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAOD;;EAEE,kBAAmB;EACnB,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EACtB,eAAgB;EAChB,0BAA2B;EAC3B,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EACzB,oBAAqB;EACrB,+BAAgC;EAChC,iBAAkB;EAClB,4BAA6B;EAC7B,gBAAiB;EACjB,2BAA4B;EAC5B,mCAAoC;EACpC,kCAAmC;EACnC,eAAgB;EAChB,gBAAiB;EACjB,2BAA4B;EAC5B,4DAA6D;EAC7D,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,2CAA4C;EAC5C,uBAAwB;EACxB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAClC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAED;EACE,kBAAmB;EACnB,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EACtB,eAAgB;EAChB,0BAA2B;EAC3B,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EACzB,oBAAqB;EACrB,+BAAgC;EAChC,iBAAkB;EAClB,4BAA6B;EAC7B,gBAAiB;EACjB,2BAA4B;EAC5B,mCAAoC;EACpC,kCAAmC;EACnC,eAAgB;EAChB,gBAAiB;EACjB,2BAA4B;EAC5B,4DAA6D;EAC7D,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,2CAA4C;EAC5C,uBAAwB;EACxB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAClC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAED;EACE,kBAAmB;EACnB,gEAAiE;EACjE,qBAAsB;EACtB,qBAAsB;EACtB,eAAgB;EAChB,0BAA2B;EAC3B,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,wBAAyB;EACzB,oBAAqB;EACrB,+BAAgC;EAChC,iBAAkB;EAClB,4BAA6B;EAC7B,gBAAiB;EACjB,2BAA4B;EAC5B,mCAAoC;EACpC,kCAAmC;EACnC,eAAgB;EAChB,gBAAiB;EACjB,2BAA4B;EAC5B,4DAA6D;EAC7D,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,qEAAsE;EACtE,kBAAmB;EACnB,6BAA8B;EAC9B,oEAAqE;EACrE,qCAAsC;EACtC,yBAA0B;EAC1B,oCAAqC;EACrC,2CAA4C;EAC5C,uBAAwB;EACxB,kBAAmB;EACnB,6BAA8B;EAC9B,kBAAmB;EACnB,6BAA8B;EAC9B,sBAAuB;EACvB,iCAAkC;EAClC,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;EAC3B,eAAgB;EAChB,0BAA2B;AAC5B;AAGD;EAGE,wBAAyB;AAC1B;AAED;EACE,6BAA8B;EAC9B,mCAAoC;EACpC,kCAAmC;EACnC,mCAAoC;EACpC,oCAAqC;EACrC,iBAAkB;EAClB,wBAAyB;EACzB,eAAgB;EAChB,eAAgB;EAChB,gBAAiB;EACjB,yDAA0D;AAC3D;AAGD;EACE,mFAAoF;AACrF;AAOD;EACE,aAAc;AACf;AACD;;;;EAIE,8BAA+B;EAC/B,mBAAoB;AACrB;AAGD;EACE,eAAgB;AACjB;AAGD;EACE,YAAa;AACd;AAGD;EACE,eAAgB;AACjB;AAGD;EACE,UAAW;AACZ;AACD;EACE,uBAAwB;AACzB;AACD;EACE,iCAAkC;EAClC,kBAAmB;AACpB;AACD;EACE,mCAAoC;AACrC;AAGD;EACE;IAAO,UAAW;EAAE;EACpB;IAAO,UAAW;EAAE;AACrB;AAED;EACE,0CAA2C;AAC5C;AASD;EACE,gBAAiB;AAClB;AAGD;EAAe,iCAAkC;AAAE;AACnD;EAAe,gCAAiC;AAAG;AAGnD;;;;EAIE,eAAgB;AACjB;AAGD;;EAEE,yBAA0B;EAC1B,+BAAgC;AACjC;AAGD;EACE;IAAK,0BAA2B;EAAE;EAClC;IAAM,iCAAkC;EAAE;EAC1C;IAAM,8BAA+B;EAAE;EACvC;IAAM,kCAAmC;EAAE;EAC3C;IAAO,0BAA2B;EAAE;AACrC;AACD;EACE;IAAK,0BAA2B;EAAE;EAClC;IAAM,kCAAmC;EAAE;EAC3C;IAAM,8BAA+B;EAAE;EACvC;IAAM,iCAAkC;EAAE;EAC1C;IAAO,0BAA2B;EAAE;AACrC;AACD;EACE;IAAK,0BAA2B;EAAE;EAClC;IAAM,gCAAiC;EAAE;EACzC;IAAM,6BAA8B;EAAE;EACtC;IAAM,iCAAkC;EAAE;EAC1C;IAAO,0BAA2B;EAAE;AACrC;AAGD;EACE,kCAAmC;AACpC;AAGD;EACE,wCAAyC;EACzC,sCAAuC;AACxC;AAED;EACE,2CAA4C;EAC5C,uCAAwC;AACzC;AAGD;EACE,yCAA0C;AAC3C;AAED;EACE,0CAA2C;EAC3C,gCAAiC;AAClC;AAED;EACE,qCAAsC;AACvC;AAED;EACE;IAAK,sBAAuB;IAAC,YAAa;EAAE;EAC5C;IAAM,sBAAuB;IAAC,UAAW;EAAE;EAC3C;IAAO,sBAAuB;IAAC,YAAa;EAAE;AAC/C;AAGD;EACE,wBAAyB;AAC1B;AAID;EACE,mCAAoC;EACpC,wCAAyC;EACzC,sCAAuC;EACvC,6BAA8B;EAC9B,4BAA6B;EAC7B,oEAAqE;AACtE;AAED;EACE,yCAA0C;EAC1C,mCAAoC;EACpC,sCAAuC;AACxC;AAED;EACE,wBAAyB;EACzB,wCAAyC;EACzC,mCAAoC;EACpC,2BAA4B;AAC7B;AAED;EACE,yCAA0C;AAC3C;AAED;;;EAGE,2CAA4C;EAC5C,2CAA4C;EAC5C,uCAAwC;EACxC,2BAA4B;AAC7B;AAED;EACE,8BAA+B;EAC/B,wBAAyB;EACzB,2BAA4B;AAC7B;AAED;EACE,gCAAiC;AAClC;AAED;EACE,yBAA0B;AAC3B;AAED;EACE,yBAA0B;AAC3B;AAED;EACE,mCAAoC;AACrC;AACD;EAGE,4CAA6C;AAC9C;AACD;EACE,2CAA4C;AAC7C;AAED;;;EAGE,6BAA8B;EAC9B,2BAA4B;AAC7B;AAED;EACE,+BAAgC;AACjC;AAED;EACE,gCAAiC;AAClC;AAED;EACE,+BAAgC;AACjC;AAED;EACE,gCAAiC;AAClC;AAED;EACE,kCAAmC;AACpC;AAED;EACE,8BAA+B;AAChC;AAED;EACE,gCAAiC;AAClC;AAED;EACE,iCAAkC;AACnC;AAED;EACE,8BAA+B;AAChC;AAED;EACE,qCAAsC;AACvC;AAED;EACE,gCAAiC;EACjC,gCAAiC;EACjC,yBAA0B;AAC3B;AAED;EACE,sCAAuC;AACxC;AAED;EACE,qBAAsB;AACvB;AAED;EACE,wBAAyB;AAC1B;AAED;EACE,8BAA+B;AAChC;AAED;EACE,2BAA4B;AAC7B;AAED;EACE,kCAAmC;EACnC,wBAAyB;AAC1B;AAED;EACE,+BAAgC;EAChC,wBAAyB;AAC1B;AAED;EACE,gCAAiC;AAClC;AAED;EACE,oCAAqC;AACtC;AAGD;EACE,yBAA0B;EAC1B,uBAAwB;EACxB,gBAAiB;AAClB;AACD;EACE,kBAAmB;AACpB;AACD;EACE,wBAAyB;EACzB,yBAA0B;EAC1B,wBAAyB;AAC1B;AACD;EACE,wBAAwE;EAAxE;IAAA,uEAAwE;EAAA;AACzE;AACD;EACE,uBAAwB;EACxB,yBAA0B;AAC3B;AAOD;EACE;IACE,uBAAwB;IACxB,4BAA6B;IAC7B,qDAAsD;EACvD;EACD;IACE,wBAAyB;EAC1B;AACF;AAGD;EACE;IAAc,eAAgB;EAAE;EAChC;IAAiB,eAAgB;EAAE;EACnC;IAAgB,SAAU;EAAE;EAC5B;IAAe,aAAc;IAAC,mBAAoB;EAAE;EACpD;IAAgB,mBAAoB;EAAE;EACtC;IAAa,mBAAoB;EAAE;EAGnC;;IAEE,4BAA6B;IAC7B,0BAA2B;EAC5B;EACD;IACE,6BAA8B;IAC9B,0BAA2B;EAC5B;EAGD;IACE,uBAAwB;IACxB,+BAAgC;IAChC,0BAA2B;EAC5B;EACD;IACE,uBAAwB;IACxB,8BAA+B;EAChC;EAGD;IACE,8BAA+B;EAChC;EAGD;IACE,wCAAyC;IACzC,4BAA6B;EAC9B;EACD;IACE,wBAAyB;EAC1B;EAGD;IACE,2BAA4B;EAC7B;EACD;IACE,wBAAyB;EAC1B;EAGD;IACE,wBAAyB;EAC1B;EACD;IACE,0BAA2B;EAC5B;EAGD;IACE,4BAA6B;EAC9B;EACD;IACE,0BAA2B;IAC3B,yBAA0B;EAC3B;EAGD;IACE,wBAAyB;IACzB,iCAAkC;EACnC;EACD;;IAEE,yBAA0B;IAC1B,sBAAuB;IACvB,4BAA6B;EAC9B;EAKD;;;IAGE,yBAA0B;IAC1B,0BAA2B;EAC5B;EAGD;IACE,0BAA2B;EAC5B;EAGD;IACE,0BAA2B;EAC5B;AACF;AAGD;EACE;IAAc,eAAgB;EAAE;AACjC;ADrJC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AA6dnB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\n\n/* Make Tailwind's `dark:` variant follow the app's dark mode\n   (:root[data-mode=\"dark\"]) instead of the OS prefers-color-scheme.\n   `data-mode` is set alongside `data-color`, so `dark:` fires for every\n   dark accent palette (Momentum, Neutral, Blue, Emerald, Violet), not just\n   Momentum dark. */\n@custom-variant dark (&:where([data-mode=\"dark\"], [data-mode=\"dark\"] *));\n\n/* ─── Map CSS variables to Tailwind color tokens ─── */\n@theme {\n  --font-sans: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n  --color-background: var(--background);\n  --color-foreground: var(--foreground);\n\n  --color-brand: var(--brand);\n  --color-brand-foreground: var(--brand-foreground);\n\n  --color-card: var(--card);\n  --color-card-foreground: var(--card-foreground);\n\n  --color-popover: var(--popover);\n  --color-popover-foreground: var(--popover-foreground);\n\n  --color-primary: var(--primary);\n  --color-primary-foreground: var(--primary-foreground);\n\n  --color-secondary: var(--secondary);\n  --color-secondary-foreground: var(--secondary-foreground);\n\n  --color-accent: var(--accent);\n  --color-accent-foreground: var(--accent-foreground);\n\n  --color-muted: var(--muted);\n  --color-muted-foreground: var(--muted-foreground);\n\n  --color-border: var(--border);\n  --color-input: var(--input);\n  --color-ring: var(--ring);\n\n  --color-destructive: var(--destructive);\n  --color-destructive-foreground: var(--destructive-foreground);\n\n  --color-success: var(--success);\n  --color-success-foreground: var(--success-foreground);\n\n  --color-warning: var(--warning);\n  --color-warning-foreground: var(--warning-foreground);\n\n  --color-info: var(--info);\n  --color-info-foreground: var(--info-foreground);\n\n  --color-live: var(--live);\n  --color-live-foreground: var(--live-foreground);\n\n  --color-gold: var(--gold);\n  --color-gold-foreground: var(--gold-foreground);\n\n  --color-sidebar-bg: var(--sidebar);\n  --color-sidebar-foreground: var(--sidebar-foreground);\n  --color-sidebar-primary: var(--sidebar-primary);\n  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);\n  --color-sidebar-accent: var(--sidebar-accent);\n  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);\n  --color-sidebar-border: var(--sidebar-border);\n  --color-sidebar-ring: var(--sidebar-ring);\n}\n\n/* ══════════════════════════════════════\n   NEUTRAL THEME (Premium Indigo)\n   ══════════════════════════════════════ */\n:root[data-color=\"neutral\"] {\n  --bg-gradient: linear-gradient(180deg, #F8FBFF 0%, #F2F7FC 100%);\n  --background: #F8FBFF;\n  --foreground: #1F2937;\n\n  --card: #FFFFFF;\n  --card-foreground: #1F2937;\n\n  --popover: #FFFFFF;\n  --popover-foreground: #1F2937;\n\n  --primary: #7FAFD8;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #6A9CC8;\n\n  --secondary: #F0F6FC;\n  --secondary-foreground: #334155;\n\n  --accent: #EEF6FF;\n  --accent-foreground: #1F3A5F;\n\n  --muted: #F1F5F9;\n  --muted-foreground: #64748B;\n\n  --border: #D9E8F5;\n  --input: #D8E6F3;\n  --ring: #7FAFD8;\n\n  --chart-1: #7FAFD8;\n  --chart-2: #AFCBE8;\n  --chart-3: #F59E0B;\n  --chart-4: #10B981;\n  --chart-5: #E2EDF7;\n\n  --sidebar-gradient: linear-gradient(180deg, #F6FAFF 0%, #EAF3FC 100%);\n  --sidebar: #F0F6FC;\n  --sidebar-foreground: #1F3A5F;\n  --sidebar-primary: linear-gradient(135deg, #AFCBE8 0%, #9DBFDF 100%);\n  --sidebar-primary-foreground: #1F3A5F;\n  --sidebar-accent: #E4EFF8;\n  --sidebar-accent-foreground: #1F3A5F;\n  --sidebar-border: #D9E8F5;\n  --sidebar-ring: #7FAFD8;\n\n  --success: #ECFDF5;\n  --success-foreground: #10B981;\n  --warning: #FFFBEB;\n  --warning-foreground: #F59E0B;\n  --destructive: #EF4444;\n  --destructive-foreground: #FFFFFF;\n\n  --info: #EEF6FF;\n  --info-foreground: #7FAFD8;\n  --live: #EF4444;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #713F12;\n}\n\n/* ══════════════════════════════════════\n   PREMIUM THEME (Momentum — warm cream + orange)\n   ══════════════════════════════════════ */\n:root[data-color=\"premium\"] {\n  --bg-gradient: linear-gradient(180deg, #F7F2ED 0%, #F4EEE9 100%);\n  --background: #F4EEE9;\n  --foreground: #1A1714;\n\n  --card: #FFFFFF;\n  --card-foreground: #1A1714;\n\n  --popover: #FFFFFF;\n  --popover-foreground: #1A1714;\n\n  --primary: #F05409;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #E8480A;\n\n  --secondary: #EDE6E0;\n  --secondary-foreground: #3A332E;\n\n  --accent: #FCE9DE;\n  --accent-foreground: #C2410C;\n\n  --muted: #EDE6E0;\n  --muted-foreground: #6B645E;\n\n  --border: #E4DCD3;\n  --input: #E4DCD3;\n  --ring: #F05409;\n\n  --brand: #F05409;\n  --brand-foreground: #FFFFFF;\n  --accent-gradient: linear-gradient(135deg, #F05409, #FF7A33);\n\n  --chart-1: #F05409;\n  --chart-2: #FF7A33;\n  --chart-3: #FFB088;\n  --chart-4: #16A34A;\n  --chart-5: #EAB308;\n\n  --sidebar-gradient: linear-gradient(180deg, #FBF8F5 0%, #FBF8F5 100%);\n  --sidebar: #FBF8F5;\n  --sidebar-foreground: #3A332E;\n  --sidebar-primary: linear-gradient(135deg, #F05409 0%, #FF7A33 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #FCE9DE;\n  --sidebar-accent-foreground: #C2410C;\n  --sidebar-border: #E4DCD3;\n  --sidebar-ring: #F05409;\n\n  --success: #ECFDF5;\n  --success-foreground: #16A34A;\n  --warning: #FFFBEB;\n  --warning-foreground: #D97706;\n  --destructive: #DC2626;\n  --destructive-foreground: #FFFFFF;\n\n  --info: #FCE9DE;\n  --info-foreground: #C2410C;\n  --live: #EF4444;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #713F12;\n}\n\n/* ══════════════════════════════════════\n   BLUE THEME (Premium Purple)\n   ══════════════════════════════════════ */\n:root[data-color=\"blue\"] {\n  --bg-gradient: linear-gradient(180deg, #F8FBFF 0%, #F2F7FC 100%);\n  --background: #F8FBFF;\n  --foreground: #1F2937;\n\n  --card: #FFFFFF;\n  --card-foreground: #1F2937;\n\n  --popover: #FFFFFF;\n  --popover-foreground: #1F2937;\n\n  --primary: #7FAFD8;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #6A9CC8;\n\n  --secondary: #F0F6FC;\n  --secondary-foreground: #334155;\n\n  --accent: #EEF6FF;\n  --accent-foreground: #1F3A5F;\n\n  --muted: #F1F5F9;\n  --muted-foreground: #64748B;\n\n  --border: #D9E8F5;\n  --input: #D8E6F3;\n  --ring: #7FAFD8;\n\n  --chart-1: #7FAFD8;\n  --chart-2: #AFCBE8;\n  --chart-3: #F59E0B;\n  --chart-4: #10B981;\n  --chart-5: #E2EDF7;\n\n  --sidebar-gradient: linear-gradient(180deg, #F6FAFF 0%, #EAF3FC 100%);\n  --sidebar: #F0F6FC;\n  --sidebar-foreground: #1F3A5F;\n  --sidebar-primary: linear-gradient(135deg, #AFCBE8 0%, #9DBFDF 100%);\n  --sidebar-primary-foreground: #1F3A5F;\n  --sidebar-accent: #E4EFF8;\n  --sidebar-accent-foreground: #1F3A5F;\n  --sidebar-border: #D9E8F5;\n  --sidebar-ring: #7FAFD8;\n\n  --success: #ECFDF5;\n  --success-foreground: #10B981;\n  --warning: #FFFBEB;\n  --warning-foreground: #F59E0B;\n  --destructive: #EF4444;\n  --destructive-foreground: #FFFFFF;\n\n  --info: #EDE9FE;\n  --info-foreground: #7C3AED;\n  --live: #EF4444;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #713F12;\n}\n\n/* ══════════════════════════════════════\n   EMERALD THEME (Fresh emerald green)\n   ══════════════════════════════════════ */\n:root[data-color=\"emerald\"] {\n  --bg-gradient: linear-gradient(180deg, #F6FBF9 0%, #EFF7F3 100%);\n  --background: #F6FBF9;\n  --foreground: #14201B;\n\n  --card: #FFFFFF;\n  --card-foreground: #14201B;\n\n  --popover: #FFFFFF;\n  --popover-foreground: #14201B;\n\n  --primary: #059669;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #047857;\n\n  --secondary: #EAF6F1;\n  --secondary-foreground: #334E45;\n\n  --accent: #ECFDF5;\n  --accent-foreground: #065F46;\n\n  --muted: #F0F7F4;\n  --muted-foreground: #5B6B64;\n\n  --border: #D6EDE3;\n  --input: #CFE8DD;\n  --ring: #059669;\n\n  --chart-1: #059669;\n  --chart-2: #34D399;\n  --chart-3: #F59E0B;\n  --chart-4: #3B82F6;\n  --chart-5: #D1FAE5;\n\n  --sidebar-gradient: linear-gradient(180deg, #F2F9F6 0%, #E7F4EE 100%);\n  --sidebar: #F2F9F6;\n  --sidebar-foreground: #14483A;\n  --sidebar-primary: linear-gradient(135deg, #059669 0%, #10B981 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #DCF3EA;\n  --sidebar-accent-foreground: #065F46;\n  --sidebar-border: #D6EDE3;\n  --sidebar-ring: #059669;\n\n  --success: #ECFDF5;\n  --success-foreground: #059669;\n  --warning: #FFFBEB;\n  --warning-foreground: #D97706;\n  --destructive: #DC2626;\n  --destructive-foreground: #FFFFFF;\n\n  --info: #ECFDF5;\n  --info-foreground: #059669;\n  --live: #EF4444;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #713F12;\n}\n\n/* ══════════════════════════════════════\n   VIOLET THEME (Rich violet purple)\n   ══════════════════════════════════════ */\n:root[data-color=\"violet\"] {\n  --bg-gradient: linear-gradient(180deg, #FAF8FF 0%, #F4F0FC 100%);\n  --background: #FAF8FF;\n  --foreground: #221B2E;\n\n  --card: #FFFFFF;\n  --card-foreground: #221B2E;\n\n  --popover: #FFFFFF;\n  --popover-foreground: #221B2E;\n\n  --primary: #7C3AED;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #6D28D9;\n\n  --secondary: #F1EBFB;\n  --secondary-foreground: #4C3A63;\n\n  --accent: #F3EEFF;\n  --accent-foreground: #5B21B6;\n\n  --muted: #F4F0FA;\n  --muted-foreground: #6B6577;\n\n  --border: #E7DEF7;\n  --input: #E2D8F4;\n  --ring: #7C3AED;\n\n  --chart-1: #7C3AED;\n  --chart-2: #A78BFA;\n  --chart-3: #F59E0B;\n  --chart-4: #10B981;\n  --chart-5: #EDE9FE;\n\n  --sidebar-gradient: linear-gradient(180deg, #F6F2FE 0%, #EEE7FB 100%);\n  --sidebar: #F6F2FE;\n  --sidebar-foreground: #4C2D82;\n  --sidebar-primary: linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #E9DEFB;\n  --sidebar-accent-foreground: #5B21B6;\n  --sidebar-border: #E7DEF7;\n  --sidebar-ring: #7C3AED;\n\n  --success: #ECFDF5;\n  --success-foreground: #059669;\n  --warning: #FFFBEB;\n  --warning-foreground: #D97706;\n  --destructive: #DC2626;\n  --destructive-foreground: #FFFFFF;\n\n  --info: #F3EEFF;\n  --info-foreground: #7C3AED;\n  --live: #EF4444;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #713F12;\n}\n\n/* ══════════════════════════════════════\n   DARK THEME (Momentum — near-black + orange)\n   ══════════════════════════════════════ */\n:root[data-color=\"dark\"] {\n  color-scheme: dark;\n\n  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);\n  --background: #0A0A0A;\n  --foreground: #F5F3F1;\n\n  --card: #161513;\n  --card-foreground: #F5F3F1;\n\n  --popover: #161513;\n  --popover-foreground: #F5F3F1;\n\n  --primary: #F05409;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #FF6A2A;\n\n  --secondary: #1F1C18;\n  --secondary-foreground: #E7E3DE;\n\n  --accent: #2A1D14;\n  --accent-foreground: #FF8A3D;\n\n  --muted: #1A1714;\n  --muted-foreground: #A8A29B;\n\n  --border: rgba(255, 255, 255, 0.08);\n  --input: rgba(255, 255, 255, 0.12);\n  --ring: #F05409;\n\n  --brand: #F05409;\n  --brand-foreground: #FFFFFF;\n  --accent-gradient: linear-gradient(135deg, #F05409, #FF7A33);\n\n  --chart-1: #F05409;\n  --chart-2: #FF7A33;\n  --chart-3: #FFB088;\n  --chart-4: #34D399;\n  --chart-5: #FBBF24;\n\n  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);\n  --sidebar: #100F0D;\n  --sidebar-foreground: #CFCAC4;\n  --sidebar-primary: linear-gradient(135deg, #F05409 0%, #FF7A33 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #2A1D14;\n  --sidebar-accent-foreground: #FF8A3D;\n  --sidebar-border: rgba(255, 255, 255, 0.08);\n  --sidebar-ring: #F05409;\n\n  --success: #0B2E22;\n  --success-foreground: #34D399;\n  --warning: #2E2205;\n  --warning-foreground: #FBBF24;\n  --destructive: #F4593C;\n  --destructive-foreground: #FFFFFF;\n\n  --info: #2A1D14;\n  --info-foreground: #FF8A3D;\n  --live: #F4593C;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #FEF9C3;\n}\n\n/* ══════════════════════════════════════\n   DARK ACCENT VARIANTS\n   Momentum-dark charcoal surfaces + each accent's hue for the primary/accent\n   channels, so every palette is available in dark mode (accent × mode).\n   ══════════════════════════════════════ */\n:root[data-color=\"neutral-dark\"],\n:root[data-color=\"blue-dark\"] {\n  color-scheme: dark;\n  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);\n  --background: #0A0A0A;\n  --foreground: #F5F3F1;\n  --card: #161513;\n  --card-foreground: #F5F3F1;\n  --popover: #161513;\n  --popover-foreground: #F5F3F1;\n  --primary: #7FAFD8;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #6A9CC8;\n  --secondary: #1F1C18;\n  --secondary-foreground: #E7E3DE;\n  --accent: #1C2A38;\n  --accent-foreground: #AFCBE8;\n  --muted: #1A1714;\n  --muted-foreground: #A8A29B;\n  --border: rgba(255, 255, 255, 0.08);\n  --input: rgba(255, 255, 255, 0.12);\n  --ring: #7FAFD8;\n  --brand: #7FAFD8;\n  --brand-foreground: #FFFFFF;\n  --accent-gradient: linear-gradient(135deg, #7FAFD8, #A9CBE8);\n  --chart-1: #7FAFD8;\n  --chart-2: #AFCBE8;\n  --chart-3: #F59E0B;\n  --chart-4: #34D399;\n  --chart-5: #4B5563;\n  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);\n  --sidebar: #100F0D;\n  --sidebar-foreground: #CFCAC4;\n  --sidebar-primary: linear-gradient(135deg, #7FAFD8 0%, #6A9CC8 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #1C2A38;\n  --sidebar-accent-foreground: #AFCBE8;\n  --sidebar-border: rgba(255, 255, 255, 0.08);\n  --sidebar-ring: #7FAFD8;\n  --success: #0B2E22;\n  --success-foreground: #34D399;\n  --warning: #2E2205;\n  --warning-foreground: #FBBF24;\n  --destructive: #F4593C;\n  --destructive-foreground: #FFFFFF;\n  --info: #1C2A38;\n  --info-foreground: #AFCBE8;\n  --live: #F4593C;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #FEF9C3;\n}\n\n:root[data-color=\"emerald-dark\"] {\n  color-scheme: dark;\n  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);\n  --background: #0A0A0A;\n  --foreground: #F5F3F1;\n  --card: #161513;\n  --card-foreground: #F5F3F1;\n  --popover: #161513;\n  --popover-foreground: #F5F3F1;\n  --primary: #059669;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #047857;\n  --secondary: #1F1C18;\n  --secondary-foreground: #E7E3DE;\n  --accent: #11291F;\n  --accent-foreground: #34D399;\n  --muted: #1A1714;\n  --muted-foreground: #A8A29B;\n  --border: rgba(255, 255, 255, 0.08);\n  --input: rgba(255, 255, 255, 0.12);\n  --ring: #10B981;\n  --brand: #059669;\n  --brand-foreground: #FFFFFF;\n  --accent-gradient: linear-gradient(135deg, #059669, #10B981);\n  --chart-1: #10B981;\n  --chart-2: #34D399;\n  --chart-3: #F59E0B;\n  --chart-4: #60A5FA;\n  --chart-5: #374151;\n  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);\n  --sidebar: #100F0D;\n  --sidebar-foreground: #CFCAC4;\n  --sidebar-primary: linear-gradient(135deg, #059669 0%, #10B981 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #11291F;\n  --sidebar-accent-foreground: #34D399;\n  --sidebar-border: rgba(255, 255, 255, 0.08);\n  --sidebar-ring: #10B981;\n  --success: #0B2E22;\n  --success-foreground: #34D399;\n  --warning: #2E2205;\n  --warning-foreground: #FBBF24;\n  --destructive: #F4593C;\n  --destructive-foreground: #FFFFFF;\n  --info: #11291F;\n  --info-foreground: #34D399;\n  --live: #F4593C;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #FEF9C3;\n}\n\n:root[data-color=\"violet-dark\"] {\n  color-scheme: dark;\n  --bg-gradient: linear-gradient(180deg, #0A0A0A 0%, #0A0A0A 100%);\n  --background: #0A0A0A;\n  --foreground: #F5F3F1;\n  --card: #161513;\n  --card-foreground: #F5F3F1;\n  --popover: #161513;\n  --popover-foreground: #F5F3F1;\n  --primary: #7C3AED;\n  --primary-foreground: #FFFFFF;\n  --primary-hover: #6D28D9;\n  --secondary: #1F1C18;\n  --secondary-foreground: #E7E3DE;\n  --accent: #241B33;\n  --accent-foreground: #A78BFA;\n  --muted: #1A1714;\n  --muted-foreground: #A8A29B;\n  --border: rgba(255, 255, 255, 0.08);\n  --input: rgba(255, 255, 255, 0.12);\n  --ring: #8B5CF6;\n  --brand: #7C3AED;\n  --brand-foreground: #FFFFFF;\n  --accent-gradient: linear-gradient(135deg, #7C3AED, #8B5CF6);\n  --chart-1: #8B5CF6;\n  --chart-2: #A78BFA;\n  --chart-3: #F59E0B;\n  --chart-4: #34D399;\n  --chart-5: #374151;\n  --sidebar-gradient: linear-gradient(180deg, #100F0D 0%, #100F0D 100%);\n  --sidebar: #100F0D;\n  --sidebar-foreground: #CFCAC4;\n  --sidebar-primary: linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%);\n  --sidebar-primary-foreground: #FFFFFF;\n  --sidebar-accent: #241B33;\n  --sidebar-accent-foreground: #A78BFA;\n  --sidebar-border: rgba(255, 255, 255, 0.08);\n  --sidebar-ring: #8B5CF6;\n  --success: #0B2E22;\n  --success-foreground: #34D399;\n  --warning: #2E2205;\n  --warning-foreground: #FBBF24;\n  --destructive: #F4593C;\n  --destructive-foreground: #FFFFFF;\n  --info: #241B33;\n  --info-foreground: #A78BFA;\n  --live: #F4593C;\n  --live-foreground: #FFFFFF;\n  --gold: #EAB308;\n  --gold-foreground: #FEF9C3;\n}\n\n/* ─── Base ─── */\nhtml {\n  /* Reserve scrollbar gutter at all times — prevents content width shift\n     when scrollbar appears / disappears between pages                      */\n  scrollbar-gutter: stable;\n}\n\nbody {\n  font-family: var(--font-sans);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--background);\n  background-image: var(--bg-gradient);\n  min-height: 100vh;\n  color: var(--foreground);\n  cursor: default;\n  font-size: 14px;\n  line-height: 1.5;\n  transition: background-color 200ms ease, color 150ms ease;\n}\n\n/* ─── Momentum brand gradient (hero blocks / avatar rings / accent CTAs) ─── */\n.bg-accent-grad {\n  background-image: var(--accent-gradient, linear-gradient(135deg, #F05409, #FF7A33));\n}\n\n/* ─── Focus rings ───────────────────────────────────────────────────────────\n   Suppress the outline on mouse/touch clicks (it was drawing boxes around\n   tabs, icon buttons and the modal close-X), but keep a visible ring for\n   keyboard users. Only links & native form fields get the on-brand orange\n   ring — buttons/tabs keep their own active styling. */\n:focus:not(:focus-visible) {\n  outline: none;\n}\na:focus-visible,\ninput:not([class*=\"ant-\"]):focus-visible,\ntextarea:not([class*=\"ant-\"]):focus-visible,\nselect:not([class*=\"ant-\"]):focus-visible {\n  outline: 2px solid var(--ring);\n  outline-offset: 2px;\n}\n\n/* ─── Prevent unexpected text caret on static elements ─── */\ndiv, span, p, td, th, h1, h2, h3, h4, h5, h6, label {\n  cursor: default;\n}\n\n/* ─── Explicitly allow text cursor on inputs and editable areas ─── */\ninput, textarea, [contenteditable=\"true\"], .selectable-text {\n  cursor: text;\n}\n\n/* ─── Re-allow pointer cursor on interactive elements ─── */\na, button, [role=\"button\"], .cursor-pointer {\n  cursor: pointer;\n}\n\n/* ─── Sidebar scrollbar ─── */\n.sidebar-scroll::-webkit-scrollbar {\n  width: 4px;\n}\n.sidebar-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n.sidebar-scroll::-webkit-scrollbar-thumb {\n  background: var(--sidebar-border);\n  border-radius: 4px;\n}\n.sidebar-scroll::-webkit-scrollbar-thumb:hover {\n  background: var(--muted-foreground);\n}\n\n/* ─── Page content entry animation (first mount only) ─── */\n@keyframes page-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.page-enter {\n  animation: page-in 140ms ease-out forwards;\n}\n\n/* ─── View Transitions ────────────────────────────────────────────────────\n   Uses the CSS-native `navigation: auto` approach (no React Router flushSync)\n   so the browser handles transitions without conflicting with Ant Design's\n   ResizeObserver inside Tabs components.\n   ─────────────────────────────────────────────────────────────────────────── */\n\n/* Enable view transitions for all same-document navigations (SPA-safe) */\n@view-transition {\n  navigation: auto;\n}\n\n/* Assign stable names to layout chrome */\n.app-sidebar { view-transition-name: app-sidebar; }\n.app-header  { view-transition-name: app-header;  }\n\n/* Sidebar & header: freeze — no fade, no movement */\n::view-transition-old(app-sidebar),\n::view-transition-new(app-sidebar),\n::view-transition-old(app-header),\n::view-transition-new(app-header) {\n  animation: none;\n}\n\n/* Main content: quick, subtle cross-fade */\n::view-transition-old(root),\n::view-transition-new(root) {\n  animation-duration: 100ms;\n  animation-timing-function: ease;\n}\n\n/* ─── Floating particle animations (circular orbits) ─── */\n@keyframes float1 {\n  0% { transform: translate(0, 0); }\n  25% { transform: translate(20px, -15px); }\n  50% { transform: translate(0, -30px); }\n  75% { transform: translate(-20px, -15px); }\n  100% { transform: translate(0, 0); }\n}\n@keyframes float2 {\n  0% { transform: translate(0, 0); }\n  25% { transform: translate(-18px, -20px); }\n  50% { transform: translate(0, -35px); }\n  75% { transform: translate(18px, -20px); }\n  100% { transform: translate(0, 0); }\n}\n@keyframes float3 {\n  0% { transform: translate(0, 0); }\n  25% { transform: translate(22px, 12px); }\n  50% { transform: translate(0, 28px); }\n  75% { transform: translate(-22px, 12px); }\n  100% { transform: translate(0, 0); }\n}\n\n/* ─── Volunteer Drawer ─── */\n.dark-glass-drawer .ant-drawer-content {\n  background: transparent !important;\n}\n\n/* ─── Checkbox Custom ─── */\n.dark-checkbox .ant-checkbox-inner {\n  background-color: var(--card) !important;\n  border-color: var(--border) !important;\n}\n\n.dark-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--primary) !important;\n  border-color: var(--primary) !important;\n}\n\n/* ─── Segmented Custom ─── */\n.dark-segmented .ant-segmented-item {\n  color: var(--muted-foreground) !important;\n}\n\n.dark-segmented .ant-segmented-item-selected {\n  background-color: var(--accent) !important;\n  color: var(--primary) !important;\n}\n\n.live-pulse {\n  animation: pulse-red-lite 2s infinite;\n}\n\n@keyframes pulse-red-lite {\n  0% { transform: scale(0.95); opacity: 0.8; }\n  50% { transform: scale(1.05); opacity: 1; }\n  100% { transform: scale(0.95); opacity: 0.8; }\n}\n\n/* ─── React Big Calendar Overrides ─── */\n.rbc-calendar {\n  color: var(--foreground);\n}\n\n/* react-big-calendar ships its own CSS (imported inside the lazy page, so it\n   loads AFTER this file) — use !important so these win the cascade. */\n.rbc-toolbar button {\n  color: var(--foreground) !important;\n  background-color: transparent !important;\n  border-color: var(--border) !important;\n  border-radius: 8px !important;\n  padding: 4px 14px !important;\n  transition: background-color 120ms ease, color 120ms ease !important;\n}\n\n.rbc-toolbar button:hover {\n  background-color: var(--muted) !important;\n  color: var(--foreground) !important;\n  border-color: var(--border) !important;\n}\n\n.rbc-toolbar button:focus {\n  outline: none !important;\n  background-color: transparent !important;\n  color: var(--foreground) !important;\n  box-shadow: none !important;\n}\n\n.rbc-toolbar button:focus:hover {\n  background-color: var(--muted) !important;\n}\n\n.rbc-toolbar button.rbc-active,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button.rbc-active:focus {\n  background-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n  border-color: var(--primary) !important;\n  box-shadow: none !important;\n}\n\n.rbc-header {\n  background-color: var(--muted);\n  color: var(--foreground);\n  border-color: var(--border);\n}\n\n.rbc-header + .rbc-header {\n  border-left-color: var(--border);\n}\n\n.rbc-off-range-bg {\n  background-color: #F8FAFC;\n}\n\n.rbc-today {\n  background-color: #EFF6FF;\n}\n\n:root[data-mode=\"dark\"] .rbc-off-range-bg {\n  background-color: var(--background);\n}\n:root[data-mode=\"dark\"] .rbc-today {\n  /* Subtle neutral highlight — the warm --accent tint turned the whole day-view\n     grid muddy brown (every cell is \"today\" in day view). */\n  background-color: rgba(255, 255, 255, 0.025);\n}\n:root[data-mode=\"dark\"] .rbc-day-slot .rbc-time-slot {\n  border-top-color: rgba(255, 255, 255, 0.04);\n}\n\n.rbc-month-view,\n.rbc-time-view,\n.rbc-agenda-view {\n  background-color: var(--card);\n  border-color: var(--border);\n}\n\n.rbc-month-row + .rbc-month-row {\n  border-top-color: var(--border);\n}\n\n.rbc-day-bg + .rbc-day-bg {\n  border-left-color: var(--border);\n}\n\n.rbc-time-content {\n  border-top-color: var(--border);\n}\n\n.rbc-time-content > * + * > * {\n  border-left-color: var(--border);\n}\n\n.rbc-timeslot-group {\n  border-bottom-color: var(--border);\n}\n\n.rbc-time-slot {\n  color: var(--muted-foreground);\n}\n\n.rbc-time-header-content {\n  border-left-color: var(--border);\n}\n\n.rbc-time-header.rbc-overflowing {\n  border-right-color: var(--border);\n}\n\n.rbc-time-gutter .rbc-timeslot-group {\n  color: var(--muted-foreground);\n}\n\n.rbc-day-slot .rbc-time-slot {\n  border-top-color: rgba(0, 0, 0, 0.05);\n}\n\n.rbc-event {\n  background-color: var(--primary);\n  color: var(--primary-foreground);\n  border-color: transparent;\n}\n\n.rbc-event.rbc-selected {\n  background-color: var(--primary-hover);\n}\n\n.rbc-show-more {\n  color: var(--primary);\n}\n\n.rbc-date-cell {\n  color: var(--foreground);\n}\n\n.rbc-off-range {\n  color: var(--muted-foreground);\n}\n\n.rbc-agenda-view table.rbc-agenda-table {\n  border-color: var(--border);\n}\n\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  border-bottom-color: var(--border);\n  color: var(--foreground);\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  border-top-color: var(--border);\n  color: var(--foreground);\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-color: var(--border);\n}\n\n.rbc-current-time-indicator {\n  background-color: var(--destructive);\n}\n\n/* ─── Icon-only buttons: bare icon, rounded fill on hover (app-wide) ─────── */\n.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-input-search-button) {\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n.ant-btn.ant-btn-icon-only:not(.ant-btn-circle) {\n  border-radius: 8px;\n}\n.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-input-search-button):not(:disabled):hover {\n  background: var(--muted);\n  border-color: transparent;\n  color: var(--foreground);\n}\n.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-input-search-button):not(:disabled):active {\n  background: color-mix(in srgb, var(--muted) 75%, var(--foreground) 10%);\n}\n.ant-btn.ant-btn-icon-only:not(.ant-btn-primary):not(.ant-btn-dangerous):disabled {\n  background: transparent;\n  border-color: transparent;\n}\n\n/* ══════════════════════════════════════\n   RESPONSIVE — Mobile & Tablet Overrides\n   ══════════════════════════════════════ */\n\n/* ─── Sidebar mobile overlay ─── */\n@media (max-width: 767.98px) {\n  .sidebar-mobile {\n    width: 270px !important;\n    transform: translateX(-100%);\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15) !important;\n  }\n  .sidebar-mobile.sidebar-mobile-open {\n    transform: translateX(0);\n  }\n}\n\n/* ─── Page layout — tighter spacing on mobile ─── */\n@media (max-width: 767.98px) {\n  .page-title { font-size: 16px; }\n  .page-subtitle { font-size: 12px; }\n  .page-content { gap: 14px; }\n  .filter-card { padding: 12px; border-radius: 12px; }\n  .content-card { border-radius: 12px; }\n  .dash-card { border-radius: 12px; }\n\n  /* Ant Design table: reduce cell padding */\n  .ant-table-thead > tr > th,\n  .ant-table-thead > tr > td {\n    padding: 8px 10px !important;\n    font-size: 11px !important;\n  }\n  .ant-table-tbody > tr > td {\n    padding: 10px 10px !important;\n    font-size: 12px !important;\n  }\n\n  /* Ant buttons: slightly smaller */\n  .ant-btn {\n    height: 34px !important;\n    padding-inline: 12px !important;\n    font-size: 12px !important;\n  }\n  .ant-btn.ant-btn-sm {\n    height: 26px !important;\n    padding-inline: 8px !important;\n  }\n\n  /* Form items: tighter spacing */\n  .ant-form-item {\n    margin-bottom: 12px !important;\n  }\n\n  /* Modal: near full-width on mobile */\n  .ant-modal {\n    max-width: calc(100vw - 24px) !important;\n    margin: 12px auto !important;\n  }\n  .ant-modal-body {\n    padding: 16px !important;\n  }\n\n  /* Drawer: full width on mobile */\n  .ant-drawer-content-wrapper {\n    max-width: 100vw !important;\n  }\n  .ant-drawer-body {\n    padding: 16px !important;\n  }\n\n  /* Card: less padding */\n  .ant-card-body {\n    padding: 14px !important;\n  }\n  .ant-card-head {\n    padding: 0 14px !important;\n  }\n\n  /* Tabs: scrollable on mobile */\n  .ant-tabs-nav {\n    flex-wrap: nowrap !important;\n  }\n  .ant-tabs-tab {\n    font-size: 12px !important;\n    padding: 8px 0 !important;\n  }\n\n  /* Descriptions: stack labels */\n  .ant-descriptions-row {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .ant-descriptions-item-label,\n  .ant-descriptions-item-content {\n    display: block !important;\n    width: 100% !important;\n    padding: 6px 12px !important;\n  }\n\n  /* Ant Col: stack on mobile when no xs prop is set\n     Target Col span={6..12} that haven't been given responsive props.\n     Force full width so form fields stack vertically. */\n  .ant-col-6,\n  .ant-col-8,\n  .ant-col-12 {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n  }\n\n  /* Segmented: allow wrapping on narrow screens */\n  .ant-segmented {\n    flex-wrap: wrap !important;\n  }\n\n  /* Steps: make compact */\n  .ant-steps-item-title {\n    font-size: 12px !important;\n  }\n}\n\n/* ─── Tablet (768px–1023px) ─── */\n@media (min-width: 768px) and (max-width: 1023.98px) {\n  .page-title { font-size: 17px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
